const tr = {
	"datalogger": {
		"cancel": "İptal etmek",
		"resetData": "Veriyi sıfırla",
		"device_upgrade": "Cihaz yazılımı güncelleniyor",
		"batchAddScq": "Toplu Veri Kaydedici Ekle",
		"updatefail": "Güncelleme başarısız oldu, cihaz çevrimdışı.",
		"Normal1": "Durum çevrimiçi",
		"deleteSuc": "Başarıyla kaldırıldı!",
		"county": "İlçe",
		"Instruction": "Talimat:",
		"select_file": "Lütfen ürün yazılımını seçin",
		"rebootDataloggerSuc": "Veri kaydedici başarıyla yeniden başlatıldı",
		"confirm_deldte": "Veri toplayıcıyı sildikten sonra, artık veri kaydediciyle ilişkili tüm verileri yönetme hakkınız yoktur.",
		"buyProfitNew": "Elektrik satın alma fiyatı",
		"datalogger_debug": "Veri Kaydedici Hata Ayıklama",
		"province": "Eyalet/Bölge",
		"clear_data": "Verileri temizle",
		"Flowcard_status": "flow card durumu",
		"reAdd": "Yeniden ekle",
		"connectionInfo": "Bağlantı Bilgileri",
		"location_info": "Konum Bilgileri",
		"editDatalogger": "Veri kaydediciyi değiştirin",
		"Status": "Durum",
		"Ple_Alias": "Lütfen veri kaydedicinin adını girin",
		"unbindResults": "Sonuçları ayır",
		"editResults": "Sonuçları değiştir",
		"upgrade": "Güncelleme",
		"edit": "Düzenlemek",
		"Offline": "Çevrimdışı",
		"Online": "Cevrimiçi",
		"timeZone": "Saat dilimi",
		"unbindDataloggerName": "Veri kaydedici bağlantısını kaldırın",
		"Communication_balance": "İletişim dengesi",
		"add_suc": "Başarıyla eklendi",
		"sellProfit": "Elektrik satış fiyatı:",
		"nominalPower": "Nominal güç",
		"Datalogger_List": "Veri kaydedicilerin listesi",
		"installer": "Kurulumcu",
		"delResults": "Sonuçları sil",
		"reset": "Tekrar yükle",
		"Datalogger_type": "Veri kaydedici tipi",
		"addResults": "Sonuçları Ekle",
		"resetTitle": "Lütfen veri kaydediciyi sıfırlamak istediğinizi onaylamak için EVET girin.",
		"upDatalogger": "Veri kaydedici güncellemesi",
		"datalogger_pn": "Veri kaydedici numarası:",
		"continueAdding": "Eklemeye devam et",
		"resetCode": "Lütfen onaylamak için EVET'e basınız",
		"city": "Şehir",
		"latitude": "Enlem",
		"notActive": "Aktif Olmayan",
		"Upload": "İndirmek",
		"prompt_message": "Hızlı ileti",
		"usr_belong": "Kullanıcı",
		"unitProfit": "Kullanılan elektriğin fiyatı:",
		"locationTip": "Faydalı ipucu: Konumlandırma yanlışsa veya konumlandırma yapılmadıysa, manuel olarak girebilirsiniz.",
		"basicInfo": "Kişisel bilgi",
		"Firmware_Version": "Donanım yazılımı sürümü",
		"upSuccessDatalogger": "Veri kaydedici başarıyla güncellendi",
		"unbindDataloggerExplain": "Bu özellik, üreticinin sevkiyat öncesi doğrulamadan sonra test hesabının (sahibinin) veri kaydedicisinden bağlantısını kaldırmasını kolaylaştırmak için kullanılır. Lütfen bu özelliği dikkatli kullanın. İşlem tamamlandıktan sonra müşterinin veri kaydediciyi yeniden bağlaması gerekir.",
		"resetDataloggerExplain": "Bu özellik, üreticilerin bulut test ekipmanı verilerini temizlemesini kolaylaştırmak için kullanılır. Veri kaydedici sıfırlandıktan sonra, cihazın geçmiş verileri silinecektir. Bir kez tetiklendiğinde, cihazın geçmiş verileri kurtarılamaz. Lütfen dikkatli ol!",
		"resetResults": "Sonuçları sıfırla",
		"currency": "Gelir para birimi:",
		"copy": "Başarılı kopyalama",
		"datalogger_name": "Veri kaydedici adı:",
		"Datalogger_model": "Model",
		"debug_suc": "Başarılı hata ayıklama",
		"cp10": "Lütfen bir proje adı girin",
		"address": "Veri kaydedici adresi",
		"cp2": "Lütfen bir saat dilimi seçin",
		"cp1": "Kurulum tarihini seçin",
		"cp4": "Lütfen bir para birimi seçin",
		"more": "Daha fazla",
		"cp3": "Lütfen nominal gücü giriniz",
		"cp6": "Lütfen bir proje seçin",
		"cp5": "Lütfen bir cihaz adı girin",
		"finishAdding": "Eklemeyi bitir",
		"cp7": "Lütfen genişliği ve uzunluğunu seçin",
		"lonRange": "- 180 ile 180 uzunlukta olan sayılar",
		"latRange": "- 90 ile 90 genişlik menzilindeki sayılar",
		"upFailDatalogger": "Veri kaydedici güncelleme hatası",
		"Normal": "Normal",
		"cp9": "Lütfen şu anda adresi girin",
		"resetSuc": "Sıfırlama tamamlandı",
		"confirm": "Onaylamak",
		"modify_datalog": "Veri kaydındaki bilgileri değiştir",
		"activeStatus": "Aktif durum",
		"com_method": "İletişim yöntemi",
		"Debugfail": "Hata ayıklama hatası, veri kaydedici devre dışı!",
		"sellProfitNew": "Elektrik satış fiyatı:",
		"uploadSuccess": "İndirme başarılı",
		"country": "Ülke",
		"location_info1": "Coğrafi bilgiler",
		"buyProfit": "Elektrik satın alma fiyatı:",
		"resetDataloggerName": "Veri kaydediciyi sıfırla",
		"Datalogger_Status": "Veri kaydedici durumu",
		"editDataloggerName": "Veri kaydediciyi sıfırla düzenle",
		"modifySuc": "Başarıyla değiştirildi",
		"Ple_PN": "Lütfen veri kaydedicinin PN numarasını girin",
		"devaddrfail": "İletişim için adres alanı boş olamaz",
		"Allstate": "Tüm durumlar",
		"longi_lati": "Boylam ve enlem",
		"create": "Yaratmak",
		"finish": "Sona ermek",
		"install_date": "Kurulum tarihi",
		"such_as": "Komutunuzu girin, örneğin: AA BB CC DD EE FF",
		"signal": "sinyal",
		"longitude": "Boylam",
		"unbindSuc": "Bağlantı başarıyla çözüldü",
		"editSuc": "Veri kaydedici değişikliği başarılı",
		"add": "Cihaz oluştur",
		"Offline1": "Çevrimdışı durum",
		"enterPosition": "Veri kaydedici giriş adresi",
		"upBatchDataloggerTip": "Not: Toplu güncelleme, birden çok veri kaydedici için aynı veri kaydedici aygıt yazılımını güncellemek içindir. Veri kaydedici için hangi donanım yazılımının uygun olduğunu bilmiyorsanız, lütfen tedarikçiyle iletişime geçin!",
		"unbindTitle": "Veri kaydedici ile terminalin mevcut sahibi arasındaki bağlantıyı kaldırmak istediğinizi onaylamak için lütfen EVET'i girin.",
		"update_suc": "Başarıyla güncellendi",
		"flowCard": "Geçerli kart bulunamadı",
		"Active": "Etkin",
		"unbind": "Çözmek",
		"return_content": "İade içeriği:",
		"district": "İdari bölge",
		"rebootDataloggerName": "Veri kaydediciyi yeniden başlat",
		"send": "Göndermek",
		"Datalogger_PN": "cihaz PN'si",
		"generateProfitNew": "Enerji üretim maliyeti",
		"Datalogger_Name": "Veri kaydedici adı",
		"file_fist": "İlk önce ürün yazılımını seçin",
		"income_info": "Gelir Bilgileri",
		"timezone": "Saat dilimi",
		"addedSuccessfully": "Başarıyla eklendi",
		"unbindUsr": "Sahibin bağını kaldırma",
		"Operation": "Çalışmak",
		"GPRS_traffic": "GPRS trafiği",
		"delete": "Silmek",
		"nowNoAdd": "Şimdi ekleme",
		"administrator": "Yönetici",
		"dataloggerAddress": "Detaylı adres",
		"load": "Yüklemek",
		"addSuc": "Veri kaydediciyi başarıyla eklemek",
		"Datalogger_method": "İletişim yöntemi",
		"fixOnRebootDataloggerName1": "Bu",
		"fileExceed": "Dosya boyutu aşıldı",
		"reboot": "Yeniden başlat",
		"generateProfit": "Enerji üretim maliyeti:",
		"noNegative": "Lütfen negatif bir numara girin",
		"basic_info": "Kişisel bilgi",
		"debug": "Hata ayıklama",
		"fixOnRebootDataloggerName": "Veri kaydedicinin yeniden başlatılmasını onaylayın:",
		"select_firmware": "Lütfen donanım yazılımı dosyasını seçin",
		"communication_address": "İletişim Adresi:",
		"check": "Kontrol",
		"InstructionType": "Talimat Formatı",
		"endMarker": "Bitiş İşareti",
		"noMarker": "Bitiş İşareti Yok",
		"noCheck": "Kontrol Yok",
		"InstructionIssue": "Talimat Gönder",
		"Insufficient": "Yetersiz Sayı",
		"add_datalogger": "Veri kaydedici ekle",
		"currentAddress": "Mevcut adres:",
		"deleteTitle": "Veri kaydediciyi sil",
		"timezone1": "Saat dilimi",
		"addScq": "Veri kaydedici ekle",
		"instruction_response": "Talimatlar gönderiliyor, yanıt bekleniyor...",
		"error1": "Yalnızca .bin ve .hex biçimlerindeki dosyaları yükleyebilirsiniz!",
		"dataloggerTipName": "Kolleksiyoncu, Rusça'da birini ekledi.",
				"batch_edit_datalogger": "Veri kaydedici toplu düzenleme",
				"upload_column_tips": "Hatırlatma: A Sütunu Veri Kaydedici PN, B Sütunu yük sayısı, C Sütunu baud hızı, D Sütunu iletişim protokolü, E Sütunu cihaz üretici kodu, F Sütunu protokol üretici kodu, G Sütunu toplama modu, H Sütunu min iletişim adresi, I Sütunu max iletişim adresi, başlık gerekmez, aşağıdaki resme bakın",
				"upload_csv_tips": "Hatırlatma: Dosya formatı csv olmalıdır, içerik için aşağıdaki resme bakın",
				"click_enlarge": "Detayları büyütmek için tıklayın",
						"collector_expire_time": "Kollektör son kullanma süresi",
						"collection_cycle": "Toplama döngüsü",
								"ascii_display": "ASCII Görüntüsü:"
	},
	"constant": {
		"gmt_neg_5": "(GMT-05: 00) Doğu Saati (ABD ve Kanada), Indiana (Doğu), Bogota, Lima, Quito",
		"gmt_neg_4": "(GMT-04: 00) Atlantik Saati (Kanada), Cuiaba, Georgetown, La Paz, Manaus, San Juan, Santiago, Asuncion",
		"gmt_neg_7": "(GMT-07: 00) Chihuahua, La Paz, Mazatlan (eski), Dağ Saati (ABD ve Kanada), Arizona",
		"gmt_neg_6": "(GMT-06: 00) Merkez Saati (ABD ve Kanada), Guadalajara, Mexico City, Monterrey (eski)",
		"gmt_neg_1": "(GMT-01:00) Green Cape Adaları, Azor Adaları",
		"gmt_neg_3": "(GMT-03: 00) Brasilia, Buenos Aires, Grönland, Cayenne, Fortaleza, Montevideo",
		"gmt_neg_2": "(GMT-02:00) Orta Atlantik Dünya Koordineli Saati-02",
		"gmt_11": "(GMT +11:00) Magadan, Solomon Adaları, Yeni Kaledonya",
		"gmt_55": "(GMT Saati +05:30) Yeni Delhi",
		"gmt_10": "(GMT +10:00) Brisbane, Vladivostok, Guam, Port Moresby, Hobart, Canberra, Melbourne, Sydney",
		"gmt_13": "(GMT Saati +13:00) Nukualofa",
		"gmt_12": "((GMT +12:00) Auckland, Wellington, Petropavlovsk-Kamçatka-Stary, Fiji, Dünya Çapında Koordineli Zaman +12",
		"gmt_neg_9": "(Gmt Saati 09:00) Alaska",
		"gmt_neg_8": "(GMT-08: 00) Pasifik Saati (ABD ve Kanada), Baja California",
		"gmt0": "(GMT +00:00) Dünya Çapında Eşgüdümlü Saat, GMT Ortalama Saati, Dublin, Edinburgh, Londra, Lizbon, Kazablanka, Monrovia, Reykjavik",
		"gmt_9": "(GMT +09:00) Osaka, Sapporo, Tokyo, Seul, Yakutsk",
		"gangbi": "Hong Kong doları (Hong Kong doları)",
		"gmt_7": "(GMT +07:00) Krasnoyarsk, Bangkok, Hanoi, Jakarta",
		"gmt_8": "(GMT +08:00) Pekin, Chongqing, Hong Kong, Urumçi, Kuala Lumpur, Singapur, Perth, Taipei, Ulan Batur, Irkutsk",
		"gmt_5": "(GMT +05:00) Taşkent, Yekaterinburg, İslamabad, Karaçi",
		"gmt_6": "(GMT +06:00) Almatı,Novosibirsk,Astana,Dakka,Novosibirsk",
		"gmt_65": "(GMT +06:30) MyanmarName",
		"gmt_neg_11": "(GMT-11:00) Samoa, Dünya Çapında Koordineli Saat 11'dir",
		"gmt_3": "(GMT +03:00) Bağdat, Kuveyt, Riyad, Moskova, St. Petersburg, Volgograd, Nairobi",
		"ruidian": "İsveç kronu (kr)",
		"gmt_neg_12": "(GMT-12:00) Uluslararası Batı Tarihi Değişim Hattı",
		"gmt_4": "(GMT +04:00) Abu Dabi, Maskat, Erivan, Bakü, Tiflis, Kafkasya Standart Saati, Port Louis",
		"gmt_1": "(GMT +01:00) Amsterdam, Berlin, Bern, Roma, Stockholm, Viyana, Belgrad, Bratislava, Budapeşte, Orta Batı Afrika, Windhoek",
		"baxi": "Gerçek ($)",
		"gmt_2": "(GMT +02:00) Amman, Beyrut, Şam, Harare, Pretoria, Helsinki, Kiev, Riga, Sofya, Tallinn, Vilnius, Kahire, Minsk, Atina",
		"renminbi": "Yuan(￥)",
		"lubi": "RS(₹)",
		"gmt_neg_10": "(GMT Saati 10:00) Hawaii",
		"Rand": "Ruble(RUB)",
		"moxige": "Meksika Pesosu(Meksika$)",
		"yingbang": "Sterlin (£)",
		"Pakistani": "Pakistan Rupisi (rupi)",
		"aoyuan": "Avustralya Doları ($A)",
		"meiyuan": "ABD Doları ($)",
		"ouyuan": "AVRO(€)"
	},
	"cloudsUpgarde": {
		"cloudsFirmwareList": "Bulut Yükseltme Listesi",
		"cloudsFirmware": "Bulut Yükseltme Yazılımı"
	},
	"role": {
		"all": "Tümü",
		"viewer": "Güç istasyonu gözlemcisi",
		"plantOwnerNew": "Normal kullanıcı",
		"plantOwner": "İstasyon sahibi",
		"distributor": "Distribütör",
		"group": "Grup hesabı",
		"manufacturer": "Üretici hesabı"
	},
	"CollectorCountByOMSOrder": {
		"23": "Üretici kodu geçersiz. Lütfen yönetici ile iletişime geçin",
		"12": "Sipariş, geçerli bir veri toplayıcı PN numarası içermiyor, lütfen sipariş numarasını onaylayın",
		"1": "Operasyon başarısız",
		"772": "Sipariş zaten bağlantılı. Lütfen siparişteki veri kaydedicinin başka bir hesapla ilişkili olmadığını onaylayın.",
		"259": "Bu sipariş için geçersiz veri kaydediciler var. Lütfen yönetici ile iletişime geçin",
		"7": "Platform hatası",
		"8": "Reddedildi, yöneticiyle iletişime geçin",
		"261": "Atanan distribütör bulunamadı, lütfen yöneticinizle iletişime geçin"
	},
	"project": {
		"energyCurrent": "Mevcut güç",
		"tipCard": "Harita",
		"energyMonth": "Aylık enerji",
		"upload": "İndir",
		"createResults": "Sonuçlar oluştur",
		"back": "Geri dön",
		"project": "Proje",
		"createProject": "Proje oluştur",
		"deviceSn": "Cihaz seri numarası",
		"createSuc": "Oluşturma başarılı",
		"modifySuc": "Başarı",
		"delSuc": "Başarıyla kaldırıldı!",
		"upgradeSuc": "Başarıyla güncellendi",
		"tipList": "Liste",
		"moveSelect": "Seçileni taşı",
		"limit": "Görüntü boyutu 1M'den fazla değil",
		"placeholder": "Cihaz adı/SN/PN araması",
		"defaultProject": "Varsayılan proje",
		"energyDate": "Belirli tarih enerjisi",
		"editSuc": "Başarıyı Düzenle",
		"editProject": "Projeyi düzenle",
		"move": "Kaydırmak",
		"energyTotal": "Toplam enerji",
		"tipSearchPN": "Veri kaydedici",
		"editResults": "Sonuçları düzenle",
		"projectRemark": "Proje notu",
		"manageProject": "Proje yönetimi",
		"upgradeResults": "Sonuç",
		"energyYear": "Yıllık enerji",
		"delResults": "Sonuçları sil",
		"delProject": "Projeyi sil",
		"tipSearchSN": "Cihaza göre",
		"projectName": "Proje adı",
		"choice": "Seçenek",
		"projectId": "Proje kimliği",
		"moveTo": "Git"
	},
	"Upload": {
		"Upload": "İndirmek"
	},
	"login": {
		"code": "Bulmacayı tamamlamak için alttaki kaydırma çubuğunu hareket ettirin.",
		"forgotUser": "Hesabı unuttum",
		"scanning": "Tarama",
		"loginSuc": "Giriş başarılı",
		"pv123": "PV123 ЭСС",
		"YZcode": "Lütfen doğrulama kodunu girin",
		"login": "Giriş yap",
		"scan_download": "uygulamayı indirin",
		"YHLogin": "Kullanıcı oturum açma",
		"scan_login": "Tarama kodu oturumu açma",
		"usr": "Kullanıcı adı",
		"SmartESS": "SmartESS",
		"forgotPwd": "Şifrenizi mi unuttunuz?",
		"app_download": "uygulamayı indirin",
		"invitationLogin": "exp kodu ile giriş yap",
		"pwdformat": "Geçersiz şifre biçimi (6<=şifre hanesi<=32)",
		"usrformat": "Geçersiz hesap biçimi (2<=hesap hanesi<=32)",
		"Pleaseconfirm_login": "Lütfen girişi onaylayın",
		"remember_pwd": "Beni hatırla",
		"YZcode_format": "doğrulama kodunun yanlış biçimi. Lütfen bir numara giriniz",
		"invitation": "Exp kodu",
		"no_invitation": "Henüz exp kodu yok mu? Lütfen bizimle iletişime geçin!",
		"signup": "Kayıt olmak",
		"linkman": "Energon",
		"sample_station": "Demo",
		"X_Tech": "X-Tech",
		"success": "Başarı",
		"no_account_yet": "Hesabınız yok mu?",
		"Scancode_login": "Tarama kodu oturumu açma",
		"pwd": "Şifre",
		"open": "açmak",
		"Swipe_right": "Sağa kaydırın",
		"no_validitycode": "Davet kodu geçerli değil",
		"auto_login": "Автоматический вход",
	},
	"customize": {
		"orange": "Turuncu",
		"green": "Yeşil",
		"classic": "Pembe",
		"blue": "Mavi",
		"purple": "Menekşe",
		"switchSkin": "Dış görünümü değiştir"
	},
	"password": {
		"PLConfig_newpassword": "Lütfen yeni şifreyi onaylayın",
		"Current_password": "Eski Şifre:",
		"User_name": "Kullanıcı adı:",
		"PLNew_password": "Lütfen yeni bir şifre girin",
		"New_password": "Yeni şifre:",
		"Save": "Kaydetmek",
		"PLCurrent_password": "Lütfen eski şifreyi girin",
		"editPwdSuc": "Şifre güncellendi",
		"Config_newpassword": "Yeni Şifre:",
		"loginAgain": "Şifre başarıyla değiştirildi, lütfen tekrar giriş yapın",
		"Password": "Temel bilgiler"
	},
	"recharge": {
		"cancel": "iptal et",
		"early_warning": "Trafik kartı sona ermek uyarısı",
		"orderno": "sıra numarası",
		"Recharge_tip4": "PayPal için kayıtlı kullananları tavsiye et",
		"recharge_type": "tür",
		"Recharge_tip3": "Onu zaten kurulan WeChat kullanıcıları için önerildi",
		"Recharge1": "Veri yeniden yükleme",
		"rechargeStatus": "Tekrar yükleme durumu",
		"Recharge_tip5": "WeChat Pay",
		"openWx": "Lütfen telefonunuzda WeChat'ı açın.",
		"Hint_language": "Cihazınız 2G cihazı var. Sanayi ve Bilgi Teknolojisi Bakanlığı'nın istediğinde, 2G ağları yavaşça ayrılıyor. 4G aygıtları satın alıp yerine getirmek ve öneriliyor!",
		"rechMoney": "ödeme",
		"Recharge": "Tekrar yükle",
		"Recharge_tip": "Hatırlatıcını yeniden yükleyin",
		"Dead_Time": "Yetiş zamanı",
		"domestic": "evde",
		"not_for_the_time_being": "Geçici olarak işlenmemiş",
		"Hint_language1": "Yeniden yükleme sürecinde problemlerle karşılaşırsanız, lütfen 0755-89993588'de satış hizmeti sıcaklığıyla bağlantıya geçin.",
		"rechDiscount": "Artık bağlı",
		"Search": "arama",
		"warning": "erken uyarı",
		"Recharge_tip2": "Örneğin, lütfen seçin: aynı taşıma kapasitesi 1; Aynı kart tipi 4G; Genel Çin veri kartları için aynı bölgede büyük bir yenilenme",
		"Recharge_tip1": "Sadece aynı türden çoğu kart yenilenmesini destekliyor.",
		"rechScan": "Lütfen mobil WeChat'ınızı açın ve ödemeyi tamamlamak için tarayın",
		"rechTip": "Hatırlatma: 1. Sadece aynı kart türü (4G içerisindeki gibi), aynı yük kapasitesi ve aynı fakirlik azaltma platformu durumu aynı sıralar için seçilebilir (öntanımlı görüntü 1 yük kapasitesi ile paketleri gösterir ve fakirlik azaltma platformuna bağlı değil); 2. Kartları yeniden yüklenmek ve her ay 25. ve 5. arasında yeniden yüklenmek 1-14 günlük gecikme sonucu olacak. Lütfen sabırlı olun ve bekleyin.",
		"Traffic_status": "Trafik durumu",
		"Status": "Trafik kartı durumu",
		"DataloggerPN": "PN：",
		"Recharge_money": "Tekrar yükle miktarı",
		"Overdue": "Daha geçti",
		"Cancel_recharge": "Yeniden yüklemeyi iptal et",
		"Datalogger_List": "Veri koleksiyonları listesi",
		"Recharged": "Yeniden yükleme başarılı",
		"Rcharge_Month": "Ayları yeniden yükleyin",
		"Service_Area": "Hizmet alanı",
		"Datalogger_PN": "PN veri alma aygıtı sayısı",
		"rechargeDevice": "Yeniden yükleme cihazı:",
		"rechargeSucInfo": "Ödemeyi başarıyla yaptınız ve veriler 24 saat içinde hesabınıza verilecek.",
		"Confirm_recharge": "Yeniden yüklemeyi onaylayın",
		"scan": "Tara ve ödeme",
		"Paid": "Zaten ödedi.",
		"Time": "Tekrar yükleme vakti",
		"Unpaid": "Ödemez ödeme",
		"Operation": "operasyon",
		"Connecting_Devices": "Yükleme kapasitesi",
		"Recharge_reminder": "Hatırlatıcını yeniden yükleyin",
		"scanComplete": "Ödemeyi tamamlamak için tarayın",
		"unknown": "bilinmeyen",
		"rechargeChannel": "Tekrar yükleme metodu:",
		"Signal": "Sinyal değeri",
		"Plant": "Elektrik istasyonu adı",
		"rechargeDiscount": "Araştırma miktarı:",
		"expired": "Keçersiz",
		"load": "Yükleme kapasitesi",
		"Recharge_List": "Tekrar yükle listesi",
		"ccid": "Veri alma cihazı akış kartı numarası",
		"Order_Number": "sıra numarası",
		"Package_type": "Paket tipi",
		"Recharge_record": "Kayıt yeniden yükleyin",
		"DataloggerName": "alias",
		"Recharging": "Yeniden yükleniyor",
		"Recharge_Selected": "Tekrar yükle",
		"rechargeErr": "Lütfen aynı yük kapasitesi ile veri kaydedici seçin",
		"rechargePrice": "Tekrar yükleme miktarı:",
		"abroad": "dışında",
		"normal": "normal",
		"previous": "return",
		"CCID": "Veri kartı numarası",
		"CCID_time": "Veri kartının deri tarihi",
		"serial_number": "Seri numaraProduced onFirmwareCapabilities\"), String.Join (\",",
		"Activation_Time": "Etkinleştirme Zamanı",
		"confirm": "belirle",
		"Recharge_status": "Tekrar yükleme durumu",
		"Recharge_now": "Şimdi yeniden yükle",
		"Content_warning": "Sevgili kullanıcı, merhaba! Aygıtınızın veri kartının sona ermek üzere bulundu. Zamanla yeniden yüklemek başarısız, operatör tarafından iptal edilen veri kartının sonucu olabilir ve kullanmaya devam edemeyecektir. Normal kullanımınıza etkilenmemek için, lütfen uyarı durumu ile aygıtları zamanla yeniden yükleyin!",
		"Recharge_fail": "Yeniden yükleme başarısız oldu",
		"rechargePackage": "Paketi yeniden yükle:",
		"rechargeSuc": "Ödeme başarılı.",
		"pn": "PN veri alma aygıtı sayısı",
		"Tips": "Tips",
		"Recharge_successful": "Yeniden yükleme başarılı",
		'Recharge_tip6': 'Ci sono schede che non supportano la ricarica,Lütfen yöneticiye bağlantı edin',
		'area_domestic': 'Çin Mainland',
		'area_abroad': 'uluslararası',
				'remedy_title': 'Şarj siparişi düzeltme',
				'upload_tip': 'Dostça hatırlatma: Yükleme dosya formatı .txt\'dir'
	},
	"auxiliary": {
		"chartSupplement": "Gerçek Grafik",
		"auxiliaryFunction": "Yardımcı fonksiyon",
		"realChart": "Açıldıktan sonra grafik gerçek verileri görüntüler."
	},
	"rate": {
		"cancel": "İptal etmek",
		"buy_Rates": "Güç satın alma fiyatı:",
		"device_status": "Cihaz durumu",
		"generate_Rates": "Elektrik üretim fiyatı:",
		"edit": "Düzenlemek",
		"Income_currencys": "Gelir para birimi:",
		"sell_Rates": "Güç satış fiyatı",
		"datalogger_pns": "Veri kaydedici numarası:",
		"resetSuc": "Sıfırlama tamamlandı",
		"sell_Rate": "Güç satış fiyatı",
		"generate_Rate": "Elektrik üretim fiyatı",
		"modifySuc": "Başarıyla değiştirildi",
		"confirm": "Onaylamak",
		"buy_Rate": "Güç satın alma fiyatı",
		"rate": "Ücret",
		"rate_list": "Tarifeler listesi",
		"operating": "Çalışmak",
		"Income_currency": "Gelir para birimi",
		"datalogger_name": "Veri kaydedici adı",
		"datalogger_pn": "Veri kaydedici numarası",
		"unbindSuc": "Bağlantı başarıyla çözüldü",
		"status": "Durum"
	},
	"intro": {
		"step_operate_1": "Ekipman bilgilerinin daha net yerleşim düzeni",
		"step_operate_2": "Ekipmanı seçtikten sonra güç akış şemasını, ekipman bilgilerini, veri tablosunu, parametre analizini, detaylı verileri ve ekipman alarm bilgilerini hızlı bir şekilde görüntüleyebilirsiniz.",
		"step_device_10": "Sizin için önemli olan ekipmanı bulmak için size uygun olan nedir?",
		"step_project_5": "yeni, değiştirmek, silmek",
		"step_project_4": "Fonksiyonlar, pozisyonlara göre ekipman yönetimi. Kullanıcılar projeyi değiştirebilir",
		"slider_quite": "İndirmeden sayfasından çık",
		"step_project_3": "Proje yönetimi",
		"step_project_2": "Son eklenenler",
		"step_project_1": "Yeni sistemin bileşimini yönetme",
		"step_device_6": "Cihazdayken \"Abone Ol\" düğmesine tıklayabilirsiniz.",
		"step_device_7": "Uyarıdan sonra",
		"step_device_8": "Ekipmanlar bu projede şu şekilde kullanılabilir",
		"slider_next": "Sonraki adım",
		"step_device_9": "Üst",
		"new_guide": "Yeni başlayanlar kılavuzu",
		"gaa_msg": "Alarm hatırlatıcısı",
		"step_device_1": "İlgilenilen cihazları hızlıca bulun",
		"step_device_2": "Son eklenenler",
		"step_device_3": "Donanıma odaklanın",
		"slider_enter": "Yeni sürümü girin",
		"step_device_4": "Fonksiyon,",
		"step_device_5": "Farenizi üzerine getirin",
		"sys_msg": "Sistem mesajı",
		"step_mode_3": "Liste veya kart",
		"step_mode_4": "Durumunuza göre sunum şeklinizi seçebilirsiniz.",
		"step_mode_1": "En sevdiğiniz cihaz listesi stilini seçin",
		"step_mode_2": "Cihaz listesine şuradan erişilebilir:",
		"slider_pre": "Önceki adım",
				"unbind_tips": "Cihaz bir sahibe bağlı değil, lütfen önce sahibi bağlayın",
		"device_code1": "Cihaz kodu"
	},
	"alarm": {
		"Alarm_Msg": "Yeni mesaj",
		"Alarm_Event": "Alarm olayı",
		"Intro_Msg": "Yeni başlayanlar kılavuzu",
		"Alarm_Status": "Uyarı Durumu",
		"alarmNum": "Alarm olaylarının sayısı",
		"alrmDes": "Alarm filtresi açıklaması",
		"deviceFilter": "Cihaz filtresi",
		"tips": "Tavsiye",
		"details": "Detaylar",
		"alarmDetails": "Alarm ayrıntıları",
		"alarmInfo": "Alarm durumu",
		"alarmDevice": "Cihaz bilgisi",
		"Close": "Kapalı",
		"Device_PN": "cihaz PN'si",
		"Battery": "Batarya",
		"Alarm_Type": "Etkinlik tipi",
		"warning": "Uyarı",
		"device_address": "Cihaz adresi",
		"Camera": "Kamera",
		"deviceType": "Cihaz tipi",
		"curSelected": "Şu anda seçili",
		"Status": "Durum",
		"all": "Tümü",
		"untreated": "İşlenmemiş",
		"alrmType": "Alarm tipini filtrele",
		"delete_alarm": "Bu uyarıyı silmek istediğinizden emin misiniz?",
		"Delete_selected": "Seçileni sil",
		"Microinverter": "Mikro İnvertör",
		"faultTitle": "Son 7 gün içindeki hataların sayısı",
		"warningTitle": "Son 7 gün içindeki alarm olayı sayısı",
		"Prevent_arcing_island": "İsland moduna karşı koruma cihazı",
		"device_Warning": "Donanım alarm sinyali",
		"Occurrence_time": "Ortaya çıkma zamanı",
		"device_Error": "Donanım hatası",
		"Alarm_Message": "Senin",
		"Alarm_List": "Uyarıların listesi",
		"alarmStatus": "Toplam alarm olayı sayısı",
		"combining_manifolds": "Toplayıcıları birleştirmek",
		"allAlarm": "Genel",
		"Device_Name": "Cihaz adı",
		"Device_SN": "Cihaz seri numarası",
		"Today_Alarm": "Bugün için alarm olaylar",
		"Alarm_Read": "Tüm alarm bildirimlerini okudunuz mu",
		"device_alias": "Cihaz takma adı",
		"Alarm_data": "Şu anda en son haberler yok",
		"ruleManage": "Alarm Filtreleme Kurallarını Yönetme",
		"device_Fault": "Donanım arızası",
		"deletes": "Silmek",
		"User": "Kullanıcı",
		"Cancel": "İptal etmek",
		"timeSlot": "Zaman aralığı",
		"faultNum": "Hataların sayısı",
		"Confirm": "Onaylamak",
		"ruleNew": "Yeni kural",
		"Alarm_Describe": "Alarmın açıklaması",
		"Operation": "Çalışmak",
		"storage": "Enerji depolama denetleyicisi",
		"error": "Hata",
		"Alarm_Message1": "Cihaz beliriyor",
		"offline": "Çevrimdışı",
		"Plant": "Elektrik santrali",
		"clearHistory": "Geçmişi temizle",
		"ruleName": "Kural adı",
		"Charger": "Şarj cihazı",
		"Alarm_Code": "Alarm kodu",
		"more": "Daha fazla",
		"Device_Type": "Cihaz tipi",
		"endtime": "Bitiş zamanı",
		"fault": "Hata",
		"monitor": "Env monitörü",
		"inverter": "İnvertör",
		"filterHistory": "Filtre geçmişi",
		"processed": "İşlenmiş",
		"_Data": "Veriler",
		"smart_meters": "Akıllı sayaçlar",
		"deleted_successfully": "Alarm başarıyla temizlendi",
		"view": "Göster",
		"back": "Geri",
		"exportArchive": "Arşivlenen alarmı dışa aktar",
		"archiveRecord": "Arşiv",
		"archiveTip": "Liste, işlenmemiş tüm alarmları ve 7 gün içindeki işlenmiş kayıtları içerir"
	},
	"plantCode": {
		"successfulApplication": "Başarılı başvuru, lütfen telefonunuza veya e-posta adresinize dikkat edin, en kısa sürede sizinle iletişime geçeceğiz",
		"goRegister": "Kaydolmaya git",
		"haveDevice": "Bir cihazınız varsa, lütfen kayıt olduktan sonra kullanmak için giriş yapın.",
		"code_is_required": "exp kodu gerekli",
		"useDemo": "Henüz davetiye kodu yok？Davetiye kodu yalnızca gösteri amaçlıdır",
		"pleaseName": "Lütfen adınızı giriniz",
		"PleaseNumber": "Lütfen telefon numaranızı giriniz",
		"codeApplication": "exp kodunun uygulanması",
		"pleaseCode": "Lütfen davetiye kodunu giriniz",
		"PleaseEmail": "Lütfen e-posta adresinizi giriniz",
		"PleaseCompanyName": "Lütfen şirket adını giriniz",
		"reasonNotEmpty": "Başvuru nedeni boş bırakılamaz",
		"applyNow": "Şimdi uygula",
		"PleaseApplication": "Lütfen başvuru nedenini açıklayınız",
		"PleaseCompanyAddress": "Lütfen şirket adresini giriniz"
	},
	"firmware": {
		"Firmware_limit_format": "Yalnızca .bin, .hex ve .s19 dosya formatlarına izin verilir",
		"Firmware_upload_fail": "Yükleme başarısız, lütfen tekrar deneyin!",
		"Firmware_upload_failTip": "Yükleme Başarısız",
		"Firmware_limit1": "En fazla",
		"Firmware_limit2": "dosya",
		"Firmware_limit3": "firmware",
		"Firmware_limitM": "Tek bir firmware dosya boyutu şunu geçemez:",
		"cancel": "İptal etmek",
		"Select_file": "Dosya seçin",
		"Upload1": "Dosyaları indir",
		"Size": "Boyut (KB)",
		"Firmware_desrc": "Tanım",
		"upgrade_quit1": "Güncelleme başarısız oldu ve sonlandırıldı!",
		"deleteSuc": "Başarıyla kaldırıldı!",
		"Upload": "İndirmek",
		"del_firmware": "Donanım Yazılımını Sil",
		"Upload_firmware": "İndirmek",
		"Operation": "Çalışmak",
		"downloadFirmware": "Indirmek",
		"tips": "Tavsiye",
		"deleteFirmware": "Silmek",
		"Firmware_Version": "Sürüm",
		"Firmware_List": "Donanım yazılımı ayari",
		"limit1": "Yalnızca xlsx biçimindeki dosyaları yükleyebilirsiniz",
		"limit2": "İpucu: Yüklenen dosyanın A sütunu veri kaydedici PN'dir ve B sütunu veri kaydedici takma adıdır. Başlık, aşağıda gösterildiği gibi gerekli değildir.",
		"limit": "Yalnızca .bin/.hex dosyaları, en fazla 8M",
		"limit0": "Yalnızca .bin/.hex/.s19 dosyaları, en fazla 8M",
		"FailedCancelUpgrade": "Güncelleme geri alınamadı",
		"Firmware_Lists": "Donanım yazılımı listesi",
		"uploadTips": "Lütfen donanım yazılımı dosyasını indirin",
		"limit3": "Başarıyla eklendi",
		"Upload_Time": "Yüklenme zamanı",
		"Add_Firmware": "Donanım yazılımı ekle",
		"upgrading1": "Bağlantı güncelleniyor, lütfen bekleyin",
		"Firmware_Name": "Donanım yazılımı adı",
		"upgrading": "Güncelleme",
		"editFirmware": "Düzenlemek",
		"Firmware_description": "Donanım yazılımı açıklaması:",
		"confirm": "Onaylamak",
		"upgrade_quit8": "Güncelleme İstisnası",
		"upgrade_quit7": "Başarısız",
		"noRecord": "Kayıtlar yok",
		"upgrade_quit6": "Güncelleme iptal edildi",
		"UploadTitle": "Lütfen toplu iş dosyalarını indirin",
		"enter_content": "Lütfen içeriği girin",
		"upgrade_quit5": "Güncellemede değil",
		"upgrade_quit4": "Güncelleme manuel olarak iptal edildi",
		"upgrade_quit3": "Başarıyla güncellendi",
		"delete_firmware": "Donanım yazılımını kaldırmak istediğinizden emin misiniz?",
		"upgrade_quit2": "Güncelleme başarısız oldu, lütfen daha sonra tekrar deneyin!",
		"updateCompleted": "Güncelleme tamamlandı",
		"firmware_upgrade": "Donanım yazılımı güncellemesi",
		"CancelUpgradeSuc": "Güncelleme başarılı iptal edildi",
		"error1": "Yalnızca .bin ve .hex .s19 biçimlerindeki dosyaları yükleyebilirsiniz!",
        "error2": " Please press LFU button",
		"CancelUpgradeSuc11": "Yükseltmeyi başarıyla iptal edin, yükseltmeden önce toplayıcının buluta bağlanmasını bekleyin",
		"upgrade_wait": "Güncelleme hazırlanıyor, lütfen 1–2 dakika bekleyin",
		"upgrade_wait1": "Güncelleme hazırlığı tamamlandı. Lütfen veri toplayıcısı çevrimiçi olduktan sonra yükseltme görevini tekrar başlatın",
		"colOffline": "Datalogger çevrimdışı",
		"colUpgrading": "Zaten yükseltme işlemi devam ediyor",
		"UpgradeStarting": "Güncelleme başlatılıyor, lütfen bekleyin...",
		"upgradeSq_fail": "Datalogger yükseltmesi başarısız oldu, lütfen daha sonra tekrar deneyin!",
	},
	"map": {
		"datalogger": "Veri kaydedici adı:",
		"address": "Adres:",
		"sn": "Cihaz seri numarası:"
	},
	"group": {
		"cancel": "İptal etmek",
		"Delete": "Silmek",
		"note": "Not",
		"entername": "Lütfen bir grup adı girin",
		"deletegroup": "Grubu sil",
		"deletesuc": "Grup başarıyla silindi",
		"deleteConfirm": "Bu grubu silmek istediğinizden emin misiniz?",
		"Operate": "Çalışmak",
		"Group_name": "Grup ismi",
		"Create_groups": "Grup oluştur",
		"editsuc": "Grup düzenleme başarılı",
		"Group_name1": "Grup ismi:",
		"confirm": "Onaylamak",
		"userCount": "Kullanıcı sayısı",
		"Groups_list": "Grup listesi",
		"Edit_groups": "Grupları düzenle",
		"creatsuc": "Grup başarıyla oluşturuldu",
		"finish": "Sona ermek",
		"note1": "Not:"
	},
	"controlDeviceErrCode": {
		"11": "İzin yok, yöneticiyle iletişime geçin",
		"1": "Operasyon başarısız. Lütfen cihazınızı kontrol edin ve tekrar deneyin!",
		"2": "Yanıt zaman aşımına uğradı, lütfen tekrar deneyin!",
		"3": "Sistem hatalarla çalışıyor. Lütfen yönetici ile iletişime geçin",
		"6": "Biçim hatası, yöneticiyle iletişime geçin",
		"8": "Reddedildi, yöneticiyle iletişime geçin",
		"9": "İşlem desteklenmiyor, lütfen yöneticinizle iletişime geçin",
		"263": "Veri kaydedici şu anda devre dışı. Lütfen ekipmanı ağa bağladıktan sonra tekrar deneyin!"
	},
	"control":{
		"setting": "Verme",
		"TouSetting": "Sistem Çalışma Modu",
		"touCharge": "Şarj Önceliği",
		"touPersonal": "Kendi Kendine Tüketim",
		"touComplete": "Tam Şebeke Beslemesi",
		"touClipping": "Tepe Kesme ve Vadı Doldurma",
		"touOffgrid": "Şebekeden Bağımsız Uygulama",
		"confirmModeSwitch": "Mod Değişimi Onaylansın mı?",
		"modeSwitch": "Modu Değiştir",
		"startTime": "Başlangıç Saati",
		"endTime": "Bitiş Saati",
		"paramValue": "Lütfen Parametre Değerini Seçin",
		"Monday": "Pazartesi",
		"Tuesday": "Salı",
		"Wednesday": "Çarşamba",
		"Thursday": "Perşembe",
		"Friday": "Cuma",
		"Saturday": "Cumartesi",
		"Sunday": "Pazar",
		"syncSetDay": "Senkron Günlük Verme",
		"time": "Zaman Aralığı 1",
		"time1": "Zaman Aralığı 2",
		"time2": "Zaman Aralığı 3",
		"time3": "Zaman Aralığı 4",
		"time4": "Zaman Aralığı 5",
		"time5": "Zaman Aralığı 6",
		"setFail": "Verme Başarısız Oldu",
		"readFail": "Okuma Başarısız Oldu",
		"charge": "Şarj Et",
		"discharge": "Deşarj Et",
		"reading": "Başarıyla Okundu",
		"reading_loading": "Okunuyor...",
		"pvMode": "Şebeke Besleme Modu",
		"screenshot": "Ekran Görüntüsü"
	},
	"statistic": {
		"All": "Tümü",
		"bc": "Verileri yükle",
		"normal": "Normal",
		"other": "Başka",
		"totalRegion": "Tüm bölge",
		"totalDevice": "Tüm cihazlar",
		"standby": "Bekleme modu",
		"regiontotal": "Toplam alanı",
		"sy": "Cihaz verileri",
		"pv": "Güneş paneli verileri",
		"active": "Aktif",
		"allDevice": "Tüm cihazlar",
		"fault": "Hata",
		"generalAccount": "Sahip Kullanıcılar",
		"deviceStatus": "Cihaz durumu",
		"allAccount": "Tüm kullanıcılar",
		"offline": "Çevrimdışı",
		"regionPercent": "Bölgesel oranı",
		"bt": "Batarya verileri",
		"inactive": "Aktif değil",
		"Allstate": "Tüm durumlar",
		"adminAccount": "Distribütör Kullanıcısı",
		"warning": "Uyarı",
		"userActivity": "Kullanıcı etkinlik düzeyi",
		"dataUpdateTime": "Veri güncelleme zamanı",
		"gd": "Ağ verileri"
	},
	"settingalarm": {
		"Delete": "Silmek",
		"Add": "Eklemek",
		"cancel": "İptal etmek",
		"Warning": "Uyarı",
		"deletes": "Silmek",
		"Email": "E-posta",
		"Add_suc": "E-posta başarıyla ekleniyor",
		"suredelete": "E-posta bildirimi silinsin mi?",
		"Yes": "Evet",
		"Fault": "Hata",
		"Operation": "Çalışmak",
		"E_Mail": "E-posta:",
		"delete": "E-postayı başarıyla silin!",
		"chosesstation": "Lütfen bir elektrik santrali seçin",
		"Receiving_Plant": "Santral alıcısı",
		"Plant": "Elektrik santrali",
		"Alarm_Type": "Alarm tipi:",
		"create": "Yaratmak",
		"Monthly_Report": "Aylık rapor",
		"Add_Mailbox": "Posta kutusu eklemek",
		"No": "Hayır",
		"Yearly_Report": "Yıllık rapor",
		"edit": "Düzenlemek",
		"addEmails": "E-posta ekleyin",
		"Error": "Hata",
		"list": "Hayır",
		"Email_Setting": "E-posta kurulumu",
		"Email_List": "E-posta Listesi",
		"Receiving_Report": "Rapor alma",
		"Alarm_Typetabel": "Etkinlik tipi",
		"Delete_Mailbox": "Posta kutusunu sil",
		"Daily_Report": "Günlük rapor"
	},
	"message": {
		"cancel": "İptal etmek",
		"pwd_is_required": "Şifre boş olamaz",
		"id_is_required": "Gruplandırma boş olamaz",
		"email_info": "Lütfen 64 basamaklı geçerli bir e-posta adresi girin",
		"delete_plant": "Elektrik santralini sil",
		"Exporting_the_report": "Dışa aktarmayı bildir",
		"length6_20": "Sadece 6-20 harf, rakam, alt çizgi girilebilir",
		"length6_32": "6'dan 32'ye kadar sayılar",
		"nodata": "Kayıt yok",
		"oldPass_wrong": "Eski şifre yanlış, lütfen tekrar girin",
		"invitation_is_required": "exp kodu gerekli",
		"length2_32": "2'den 32'ye kadar sayılar",
		"pwdSame": "Eski ve yeni şifreler eşleşemez",
		"pn_is_required": "PN boş olamaz",
		"pwdAgain": "Şifreyi onaylayın",
		"search": "Aramak",
		"pwdNotsame": "İki oturum açma şifresi uyuşmazlığı",
		"length2_64": "2'den 64'e kadar sayılar",
		"uname_is_required": "Hesap boş olamaz",
		"Logging_off": "Bu hesap iptal edildi ve oturum açılamıyor",
		"modify_plant": "Enerji santralini değiştir",
		"PN_info": "PN, en az bir büyük harf dahil olmak üzere 14 veya 18 bit uzunluğundadır.",
		"confpwd_is_required": "Şifre doğrulama alanı boş olamaz",
		"mobile_is_required": "Telefon numarası boş olamaz",
		"email_is_required": "E-posta boş olamaz",
		"country_is_required": "Lütfen bir ülke veya bölge seçin",
	},
	"menu": {
		"datalogger": "Veri kaydedici",
		"Total_user": "Toplam Kullanıcı:",
		"customize": "Veri değişim hızını ayarlama",
		"setting": "Sistem ayarları",
		"password": "Temel bilgiler",
		"rate": "Doldurma işlemi kaydı",
		"recharge": "Mobil ayar",
		"record": "Trafik yenileme",
		"alarm": "Alarm",
		"firmwarenew": "Donanım yazılımı ayari",
		"adaptiveFirmware": "Uyarlanabilir Donanım Yazılımı",
		"intelligenceUpgrade": "Akıllı Yükseltme",
		"intelligenceUpgradeTitle": "Yükseltme paketi yok, lütfen üreticiyle iletişime geçin",
		"intelligenceUpgradeTitle1": "Cihazın akıllı yükseltme yapmasını onaylıyor musunuz?",
		"intelligenceUpgradeTitle2": "Eşleşen yükseltme paketi bulunamadı",
		"firmware": "Kullanıcı ayarı",
		"email": "Acil durum uyarısını ayarlama",
		"myDevice": "Cihazım",
		"overview": "Gözden geçirmek",
		"functionalApplication": "Fonksiyonel Uygulama",
		"mobile": "E-posta ayarı",
		"pay": "Şarj ayarı",
		"personal": "Parametre",
		"alarmSetting": "Şifre değiştir",
		"home": "Başa dön",
		"browseAccount": "Alt hesap yönetimi",
		"cloudsUpgrade": "Bulut Yükseltme",
		"strategy": "Strateji Belirleme",
		"basic": "Kişisel bilgi",
		"device": "Cihaz",
		"account": "Hesap",

		"log": "Data logger log",
		"actionLog": "Operasyon günlüğü",
		"Manufacturer": "Yapıcı yönetimi",
		"datalogger_list": "Veri koleksiyonları listesi",
		"manufacturer_account": "Yapıcı hesabı",
		"manufacturer_code": "Yapıcı kodu",
		"protocol_binding": "Veri alma protokolü bağlaması",
		"type_code": "Veri alma aygıtı kodu yazın",
		"protocol_change": "Veri alma protokolünün değiştirmesi",
		"AIP_Interface": "API arayüzü arayüzü",
		"protocol_operation": "Protocol operation tool",
		"recharge_management": "Yeniden yükleme yönetimi",
		"device_management": "aygıt yönetimi",
		"KEY_List": "KEY Listesi",
		"Protocol_instruction": "Protokol talimatı yönetimi",
		"Raw_data": "Zehirli veri analizi",
		"Recharge_remedy": "Yeniden yükleyin",
		"device_function": "Equipment yönetim fonksiyonu",
		"Password_maintenance": "Kontrol öğeleri parola tutma",
	},
	"signup": {
		"too_simple": "Şifre çok basit, lütfen tekrar girin",
		"code": "6 basamaklı doğrulama kodu",
		"qiangdu": "Şifre güvenlik seviyesi:",
		"di": "Zayıf",
		"registered": "Kayıt olmak",
		"login": "Giriş yapmak",
		"confirm_Pwdpl": "Şifreyi onayla",
		"mobile_pl": "Telefon numarası",
		"confirm_password": "Şifreyi onaylayın",
		"emailSignup": "E-posta kaydı",
		"PN_pl": "PN",
		"zhong": "Orta",
		"email_form": "64 karakter içinde, şifreyi bulmak için tam olarak girin.",
		"usr": "2-32 karakter (İngilizce, harf, sayı, alt çizgi)",
		"emailformat": "Lütfen geçerli bir posta kutusu girin",
		"email": "E-posta",
		"pwdformat": "Şifre formatı hatası, 6 ~ 32 basamak (sadece sayılar, harfler, alt çizgi)",
		"usrformat": "Hesap hatası, 2-32 basamak (yalnızca ingilizce, harfler, sayılar altı çizili)",
		"email_pl": "E-posta adresi",
		"pwd_pl": "Şifre",
		"Byte_2": "Üyeler",
		"pnformat": "PN biçim hatası, 14 veya 18 basamak (yalnızca sayılar ve harfler)",
		"Byte_1": "Zaten girildi",
		"phoneSignup": "Telefon ile kayıt",
		"mobileformat1": "Geçerli bir cep telefonu numarası girin",
		"mobileformat": "Geçersiz telefon numarası biçimi (6-32 basamak)",
		"qiang": "Güçlü",
		"code_pl": "Doğrulama kodu",
		"confirm_pl": "Şifreyi onaylayın",
		"signup": "Kayıt olmak",
		"phone": "Telefon",
		"success": "Kayıt başarılı!",
		"usr_pl": "Kullanıcı adı",
		"phone_form": "32 karakter içinde, şifreyi bulmak için tam olarak girin.",
		"Register_account": "Bir hesap oluştur",
		"existing_account": "Hali hazırda bir hesabınız var mı?",
		"pwd": "6-32 karakter (sayı, harf, alt çizgi), büyük/küçük harfe duyarlı",
		"pn": "14 veya 18 karakter (yalnızca rakamlar ve harfler)",
		"country_pl": "Ülke veya bölge",
	},
	"version": {
		"to_new": "Yeni sürüm",
		"to_old": "Önceki sürüm",
		"custom_theme": "Özel tema",
		"default_theme": "Varsayılan tema",
		"default_node": "Varsayılan düğüm"
	},
	"createPlant": {
		"fileExceed": "Dosya boyutu aşıldı",
		"Control_settings": "Akü ayarı",
		"basic_settings": "Temel ayar",
		"Basic_setting": "Temel ayar",
		"select_all": "Tümünü seç",
		"pv": "PV",
		"gd": "Şebeke",
		"bt": "Akü",
		"bc": "Yük",
		"sy": "Sistem",
		"eg": "Jeneratör",
		"hl": "EvselYük",
		"System_settings": "Sistem ayarları",
		"Grid_settings": "Ağ kurulumu",
		"Solar_settings": "Güneş sistemi kurulumu",
		"imageLimit": "Görseller sadece jpg, png biçimindedir ve 8 MB'ı aşamaz.",
		"Load_setting": "Ayarları indirin",
		"Standard_setting": "Standart ayarlar",
		"other_settings": "Diğer ayarlar",
		"Advanced_setting": "Gelişmiş ayarlar",
		"Battery_settings": "Batarya ayarı",
		"Battery_settingsTT": "Pil Genel Ayarları",
		"Battery_settings1": "Pil Paketi 1",
		"Battery_settings2": "Pil Paketi 2",
		"Work_settings2": "Sistem çalışma durumunu ayarla",
		"Machine_settings2": "Makine bekleme işlevini etkinleştir",
		"Clear_settings2": "Arızayı temizle",
		"uploadSuccess": "İndirme başarılı"
	},
	"upgradeManagement": {
		"cancel": "İptal etmek",
		"eidt_success": "Başarıyı Düzenle",
		"delete_success": "Cencel Başarısı",
		"edit_firmware": "Düzenlemek",
		"delete_success1": "Başarıyla kaldırıldı!",
		"download_firmware": "İndirmek",
		"upgrade_file_format1": "Sadece yükleyebilir. çöp kutusu /. onaltılık biçim",
		"upgrade_file_format2": "Dosya 1 Mb'ı geçemez",
		"Upload": "İndirmek",
		"Firmware_Version": "Sürüm",
		"firmwareName_empty": "Ürün yazılımı adı boş olamaz",
		"confirm": "Onaylamak",
		"upgrade_file_format": "Sadece yükleyebilir. çöp kutusu /. hex formatı, 1 mb'yi geçemez",
		"firmware_name": "Ürün Yazılımı Adı",
		"Remarks": "Tanım",
		"please_upgrade": "Lütfen yükleme dosyasını seçin",
		"download_firmware_prompt": "Bu bellenimi indirmek istediğinizden emin misiniz?",
		"upload_firmware": "İndirmek",
		"create": "Yaratmak",
		"please_input": "Lütfen giriş yapın",
		"firmwareVersion_empty": "Sürüm numarası boş olamaz",
		"download_success": "Başarıyı indirin",
		"delete_desc": "Silindikten sonra kurtarılması mümkün olmayacak ve bu bellenim için seçilen yükseltme stratejisi cihazı yükseltemeyecektir",
		"upgrade_success": "Yükleme başarısı",
		"download_exception": "istisna indirin, lütfen sonra tekrar deneyin",
		"upload_result": "Yükleme Sonucu",
	},
	"401": {
		"goback": "Öncekine geri dön",
		"gohome": "Başa dön",
		"oops": "Oh!",
		"noAuth": "Bu sayfaya erişiminiz yok"
	},
	"errCode": {
		"271": "Değişiklik işlemi yok",
		"272": "Bağlamayı tekrarla",
		"273": "Diğer üreticiler için eklemeyi desteklemiyor",
		"352": "Donanım yazılımını bulamıyorum",
		"353": "Rol bulunamadı",
		"276": "Diğer üreticilere ait mobil cihazları olan santral sahiplerini desteklemez.",
		"512": "SMS kimlik doğrulama kodu uyuşmazlığı",
		"513": "Doğrulama kodunun süresi doldu",
		"514": "Telefon numarası/e-posta uyuşmazlığı",
		"515": "Telefon numarası/e-posta bağlı değil",
		"516": "İsim eşleşmiyor",
		"517": "Sistem, aynı kullanıcı veya santral için bir veri kaydedici numarasına sahiptir.",
		"518": "Kullanıcının ayrıca bir alt kullanıcısı vardır.",
		"519": "Hesabı tekrarla",
		"10": "Kimlik doğrulama başarısız oldu, lütfen tekrar giriş yapın",
		"11": "Desteklenmeyen işlemler",
		"12": "Kayıtlar yok",
		"13": "Dışarıda",
		"14": "Tekrarlanan işlemler",
		"15": "Üretici anahtarı yok",
		"16": "Şifre doğrulama hatası",
		"17": "Parola biçimi hatası",
		"18": "Telefon numarası bağlı",
		"1792": "Veri toplayıcı, distribütöre ait olmalıdır",
		"19": "Telefon numarası biçimi hatası",
		"1031": "Kullanıcı bu yönetici tarafından oluşturulmadı",
		"1030": "Geçersiz GPRS kartı",
		"0": "Normal, hata yok",
		"1029": "Desteklenmeyen şarj",
		"1": "Hata",
		"1028": "Yinelenen sayıda dijital veri kaydedici numarası",
		"288": "Kamerayı bulamıyorum",
		"2": "Bir süre sonra",
		"1027": "En iyi kullanıcı bir distribütör veya ekipman üreticisi olmalıdır",
		"520": "Yinelenen PN numarası",
		"3": "Sistem hatalarla çalışıyor. Lütfen yönetici ile iletişime geçin",
		"1026": "Sadece donanım üreticileri için destek",
		"521": "Alıcı kullanıcıya ait değil",
		"4": "Doğrulayıcı olmayan İmza",
		"1025": "Sadece bayiler için destek",
		"522": "Veri kaydedici numarası zaten var",
		"368": "Anlaşma bulmak mümkün değil",
		"5": "Değer yanlış ve kurallara göre kullanılmıyor",
		"1024": "Tarayıcı hesabı değil",
		"523": "Yalnızca santral sahiplerine yönelik destek",
		"369": "Kullanıcı grupları bulunamadı",
		"6": "Parametre biçimi hatası",
		"7": "Platform hatası",
		"525": "Onay kodu gönderildi. Lütfen daha sonra tekrar deneyiniz.",
		"528": "Bu rol zaten bir kullanıcı ile bağlı ve silinemiyor",
		"8": "Ayrıcalıksız operasyon",
		"768": "Protokolde isteğe bağlı alanlar yok",
		"9": "Gerekli parametreler eksik",
		"20": "Hesap formatı hatası",
		"21": "Hesap biçimi hatası (2 <= hesap hanesi < 32)",
		"22": "Şirket adı biçim hatası",
		"23": "Üretici kodu geçersiz",
		"24": "Hesabı tekrarla",
		"25": "Hesap devre dışı bırakıldı, yöneticiyle iletişime geçin",
		"26": "E-posta bağlantılı, lütfen e-posta adresinizi değiştirin veya bağlantıyı kaldırın.",
		"27": "Hesap iptal edildi. lütfen yönetici ile iletişime geçin",
		"1042": "Geçersiz CCID",
		"1041": "Anahtar arızalı veya bulunamıyor",
		"370": "Güç grubu bulunamıyor",
		"371": "GPRS trafik yenileme paketi bulunamadı",
		"372": "Yeniden doldurma siparişi bulunamadı",
		"772": "Veri toplayıcı bağlandı",
		"256": "Kayıt yok",
		"257": "Ekipman bulunamadı",
		"258": "Cihaz bulunamıyor",
		"259": "Geçersiz PN numarası, PN numarasının doğru olup olmadığını kontrol edin",
		"260": "Santral bulunamadı",
		"261": "Kullanıcı bulunamadı",
		"262": "Ekipman devre dışı",
		"384": "Doğrulama kodu hatası",
		"263": "Veri kaydedici devre dışı",
		"385": "device_token bulunamıyor",
		"264": "Ekipman için sinyal yok",
		"386": "Cihaz yapılandırma bilgileri bulunamıyor",
		"265": "Ortam dedektörü bulunamadı",
		"387": "Veri kaydedici türü bulunamıyor"
	},
	"report": {
		"cancel": "İptal etmek",
		"select_date": "Lütfen bir tarih seçin",
		"Yearly_Report": "Yıllık rapor",
		"Export_report": "Dışa aktarmayı bildir",
		"Export_alarm": "Alarmı dışarı aktar",
		"Report_date": "Rapor tarihi:",
		"no_deAlarm": "Geçen ay hiçbir cihaz alarmı oluşmadı",
		"Report_date1": "Not. Dışa aktarma tarih aralığı 31 günü aşamaz.",
		"Total_report": "Genel rapor",
		"Subscribe_report": "Rapora abone ol",
		"customize": "Yapılandır",
		"all_reports": "Tümünü dışa aktar",
		"current": "Güncel",
		"download": "İndirme bekleniyor, lütfen bekleyin",
		"Report_type": "Rapor tipi:",
		"Export": "Dışa aktarma",
		"Daily_report": "Günlük rapor",
		"to": "K",
		"Batch_export": "Toplu dışa aktarma",
		"Monthly_report": "Aylık rapor",
		"End_date": "Son kullanma tarihi",
		"start_date": "Başlangıç ​​tarihi"
	},
	"404": {
		"notFound": "Sayfa bulunamadı!"
	},
	"retrieve": {
		"Verification_code": "Doğrulama kodu",
		"passwordPhone": "Cep telefonu numarası bağlı değil",
		"Email": "E-posta",
		"enter_code": "Lütfen doğrulama kodunu girin",
		"re-register": "Yeniden kaydol",
		"login": "Giriş yap",
		"Reset_successfully": "Sıfırlama başarılı, lütfen şifrenizi unutmayın",
		"Retrieve_passwordEmail": "E-posta yoluyla şifreyi kurtar",
		"bound_mobile": "Lütfen ilgili cep telefonu numarasını giriniz",
		"Retrieve_password": "Şifre al",
		"passwordPhone1": "Cep telefonu numarası eşleşmiyor",
		"Confirmloginpassword": "Yeni oturum açma şifresini onaylayın",
		"Get_codeSucc": "Doğrulama kodu başarıyla alındı",
		"New_password": "Yeni Şifre",
		"email_first": "Lütfen önce e-posta adresinizi girin",
		"code_1minute": "Cep telefonunuza doğrulama kodu gönderilmiştir ve giriş 1 dakika süreyle geçerlidir.",
		"finish": "Sona ermek",
		"Retrieve_passwordPhone": "Cep telefonu tarafından alınan şifre",
		"bound_email": "Lütfen bağlı e-posta adresinizi girin",
		"Email_verification": "Eposta Doğrulama",
		"step4": "Adım 4",
		"code_5minutes": "E-postanıza bir doğrulama kodu gönderildi ve giriş 5 dakika süreyle geçerlidir.",
		"Getting_progress": "Çalışıyor, lütfen bekleyin.",
		"Confirm_password": "Şifreyi onayla",
		"reset_Password": "Şifre sıfırlama",
		"enter_name": "Tek bir kullanıcı adı girin",
		"mobile_first": "Lütfen önce cep telefonu numaranızı giriniz",
		"Phone_verification": "Telefon kontrolü",
		"Reset_passwordSuc": "Şifre sıfırlama başarılı!",
		"step2": "Adım 2",
		"step3": "Adım 3",
		"signup": "Kayıt olmak",
		"step1": "Adım 1",
		"confirm": "Onaylamak",
		"account_password": "Lütfen şifrenizi sıfırlamak için gereken hesabı girin",
		"Change_one": "Birini değiştir",
		"Obtain_code": "Kodu al",
		"Incorrect_code": "Geçersiz onay kodu",
		"new_password": "Yeni Şifre",
		"passwordEmail1": "Posta kutusu uyuşmazlığı",
		"passwordEmail": "Eklenmemiş posta kutusu",
		"Newloginpassword": "Yeni Şifre",
		"phone_number": "Telefon numarası",
		"Verify_identidy": "Kimliği doğrula",
		"Enter_account": "Oturum açın",
		"Con_password": "Şifreyi onayla",
		"username": "Kullanıcı adı"
	},
	"header": {
		"log_out": "Çıkmak",
		"change_password": "Şifre değiştir",
		"plant_owner": "İstasyon sahibi",
		"operating_manual": "Yönetim",
		"bind_email": "E-postayı bağla",
		"bind_mobile": "Cep telefonunu bağla",
		"skin": "Dış görünümü değiştir",
		"shopping_mall": "Mall",
		"pnAndAlias": "PN / başlık",
		"pnAndSN": "PN / SN",
		"personal_infor": "Parametre",
		"pleaseSelect": "Seçmek",
		"language": "Dil",
		"pleaseSelect1": "Bir zaman seçin"
	},
	"basic": {
		"backTo": "Geri dön",
		"Change_email": "E-postayı değiştir",
		"Email": "E-posta:",
		"uploadAvatar": "Avatarı değiştir",
		"editNickname": "Takma adı değiştir",
		"bindPhone": "Telefonu bağla",
		"bindPhoneTip": "Cep telefonunuzu oturum açıp şifre alacak ve sistem tarafından gönderilen bildirimleri alacak şekilde ayarlayın.",
		"changePwdSuc": "Şifre sıfırlama başarılı!",
		"accountSecurity": "Hesap güvenliği",
		"modifySuc": "Başarıyla değiştirildi",
		"Personal_info": "Kişisel Bilgiler",
		"bindPhoneTipAfter": "Giriş yapabilir, şifrenizi kurtarabilir ve sistem tarafından gönderilen bildirimleri alabilirsiniz.",
		"Nickname": "Takma ad:",
		"bindEmailTipBefore": "Bağlantılı e-posta",
		"email_code": "E-postanıza bir onay kodu gönderildi, lütfen kontrol edin.",
		"unbinding_Em": "Bağlantı kaldırıldığında, şifrenizi sıfırlamak için e-posta kullanamayacaksınız!",
		"Bind_phone": "Cep telefonunu bağla",
		"After_bindingPh": "Şifre, bağlı telefon aracılığıyla kurtarılabilir",
		"code_frequently": "Doğrulama kodları çok sık isteniyor, lütfen daha sonra tekrar deneyin.",
		"finished": "Sona ermek",
		"Ple_Nickname": "Lütfen bir takma ad girin",
		"bindRes": "Bağlama sonucu",
		"changeBtn": "Düzenlemek",
		"setMobile": "Cep telefonu numarasını bağlayın",
		"Ple_email": "Lütfen bağlamak için bir e-posta adresi girin",
		"unbind_Ph": "Telefon numaranızın bağlantısını kaldırmak istediğinizden emin misiniz?",
		"Bind_email": "E-postayı bağla",
		"re_enter": "Yeniden almak",
		"Obtain_code": "Kodu al",
		"Change_phone": "Telefonu değiştir",
		"noHanzi": "Şifre Çince içeremez",
		"setNickname": "Takma adı ayarla",
		"suc_em": "E-posta başarıyla bağlandı",
		"Save": "Kaydetmek",
		"basic": "Parametre",
		"bindEmail": "E-postayı bağla",
		"mobile_code": "Cep telefonunuza doğrulama kodu gönderildi, lütfen kontrol ediniz.",
		"code": "Кod:",
		"setEmail1": "E-postayı bağla",
		"unbind_Em": "E-postanın bağlantısını kaldırmak istediğinizden emin misiniz?",
		"Untie_phone": "Telefonu çöz",
		"basicInfo": "Kişisel bilgi",
		"changePwd": "Şifre değiştir",
		"unbinding_Ph": "Bağlantı kaldırıldığında, şifrenizi sıfırlamak için telefonunuzu kullanamayacaksınız",
		"bindPhoneTipBefore": "Bağlı telefon:",
		"Ple_phone": "Lütfen bağlamak için bir telefon numarası girin",
		"Email1": "E-posta",
		"Email2": "E-posta:",
		"Select_all": "Geri yükle ve hepsini seç",
		"retry": "Yeniden deneme",
		"editMobile": "Cep telefonu numarasını değiştir",
		"Ple_code": "Lütfen doğrulama kodunu girin",
		"editEmail": "E-postayı değiştir",
		"User_name1": "Kullanıcı adı",
		"personalCenter": "Hesap ayarları",
		"changePwdTip": "Yüksek güvenlikli bir şifre bir hesabı daha güvenli hale getirebilir. Şifrenin düzenli olarak değiştirilmesi ve 6 ile 32 hane arasında bir şifre belirlenmesi önerilir.",
		"suc_ph": "Telefon numarası başarıyla bağlandı",
		"changeRes": "Sonuçları değiştir",
		"bindEmailTip": "Oturum açmak ve şifre almak ve ayrıca sistem tarafından gönderilen bildirimleri almak için bir e-posta ayarlayın.",
		"Unbind_email": "E-posta bağlantısını kaldır",
		"Mobile": "Mobil",
		"Avatar": "Kullanıcı гörüntüsü",
		"Mobile1": "Telefon numarası",
		"Nickname1": "Takma ad",
		"User_name": "Kullanıcı adı:",
		"After_bindingEm": "Şifre ilgili e-posta aracılığıyla alınabilir",
		"Nickname_length_tip": "Kullanıcı takma adı uzunluğu 2-32 bit"
	},
	"strategy": {
		"cancel": "İptal etmek",
		"Not_upgraded": "Yükseltilmemiş",
		"strategy_number": "Numara",
		"force_upgrade": "Yükseltmeyi Zorla",
		"strategyIntro": "Yerel yükseltme işlemine genel bakış",
		"message_baudrate": "Lütfen seçiniz Baud",
		"In_effect": "Aslında",
		"view": "Manzara",
		"strategyUpgrade": "Yükseltme Stratejisi Listesi",
		"stategyStep9": "Cihaz yükseltme durumunu ve sonuçlarını görüntüleme",
		"message_name": "Lütfen bir ilke adı girin",
		"cancel_strategy": "İptal Politikası",
		"uprade_name": "Yükseltmeyi Zorla",
		"stategyStep8": "Yükseltme kayıtlarını görüntüleme",
		"edit_strategy": "Politikayı Düzenle",
		"stategyStep7": "Yükseltme stratejisi listesine yeni bir strateji ekleyin, Bellenimi Yükselt'i seçin, yükseltme yöntemini ayarlayın ve yürürlüğe girin, yükseltme cihazını ilişkilendirin ve yükseltme stratejisini oluşturun",
		"stategyStep6": "Strateji ekle",
		"message_desc": "Lütfen bir politika açıklaması girin",
		"stategyStep5": "Strateji yürürlüğe girdikten sonra, uygulama bir yükseltme hatırlatıcısı alır ve yerel olarak yükseltebilir",
		"suggested_upgrade": "Önerilen yükseltme",
		"stategyStep4": "Uygulama Yerel Yükseltmesi",
		"add_strategy": "Yükseltme Stratejisi Listesi",
		"stategyStep3": "Ürün yazılımı sürümü paket dosyalarını yerel ürün yazılımı yönetimine yükleyin",
		"stategyStep2": "Yeni ürün yazılımı sürüm paketi",
		"End_date": "Son kullanma tarihi",
		"Upgrade_tip": "Lütfen ilkeyle ilişkili cihazı seçin",
		"edit": "Düzenlemek",
		"uprade_success": "Başarıyla güncellendi",
		"strategy_firmware": "Ürün Yazılımını Yükseltme",
		"upgrade_remind": "Yükseltme Hatırlatıcısı",
		"message_timezone": "Lütfen bir saat dilimi seçin",
		"message_type": "Lütfen donanım yazılımı türünü seçin",
		"go_back": "Geri dön",
		"Upgrade_result": "Başarıyla eklendi",
		"uprade_time": "Güncelleme zamanı",
		"message_uprade_type": "Lütfen yükseltme türünü seçin",
		"stategyDetail7": "Durum",
		"message_firmware": "Lütfen ürün yazılımını seçin",
		"start_time": "Başlama zamanı",
		"stategyDetail6": "Güncelleme ilerlemesi",
		"stategyDetail5": "Yöntem",
		"uprade_status": "Güncelleme durumu",
		"stategyDetail4": "Baud hızı",
		"TOP": "Önceki adım",
		"completion_strategy": "Tamamlama Stratejisi",
		"delete_firmware": "Bu politikayı iptal etmek istediğinize emin misiniz?",
		"stategyDetail9": "Bitiş zamanı",
		"Next": "Sonraki adım",
		"stategyDetail8": "Başlama zamanı",
		"strategy_desc": "Tanım",
		"strategy_detail": "Strateji Detayları",
		"strategy_status": "Durum",
		"Yes_started": "Yükseltildi",
		"strategy_baudrate": "Baud hızı",
		"UpgFirmware": "Yerel bellenim yönetimi",
		"delete_desc": "İptalden sonra, kurtarılması mümkün olmayacak ve seçilen yükseltme stratejisi, cihazı yükseltmesi için bilgilendiremeyecektir",
		"strategy_name": "İsim",
		"remind_desc": "Hatırlatma Açıklaması",
		"strategy_search": "İlke Kodu / İlke Adı",
		"uprade_type": "Yöntem",
		"uprade_result": "Sonuç",
		"associated_device": "İlişkili cihazlar",
		"stategyDetail3": "Ürün Yazılımı Türü",
		"stategyDetail2": "Ürün yazılımı boyutu (KB)",
		"stategyDetail1": "Ürün Yazılımını Yükseltme",
		"upgradeList": "Kayıt Listesini Yükselt",
		"message_time": "Lütfen geçerli bir saat seçin",
		"expired": "Süresi dolmuş",
		"strategyIntro1": "Açıklama: Bu işlev modülü yalnızca Bluetooth yerel ürün yazılımı yükseltmesi içindir. Wi Fi veya 4G gibi cihazların bellenimini yükseltmek istiyorsanız, lütfen [Cihaz Yönetimi Cihaz Listesi Yükseltme İşlemi] bölümüne gidin.",
		"uprade_name1": "Önerilen yükseltme",
		"view_strategy": "Politikaları Görüntüle",
		"strategy_code": "Kod",
		"upgrade_strategy_list": "Yükseltme Stratejisi Listesi",
		"start_date": "Geçerlilik tarihi",
		"default_desc1": "Bu cihazın kullanılmadan önce daha yüksek bir sürüme yükseltilmesi gerekir. Yükseltmek için 'Yükseltmeye Zorla'yı tıklayın. Lütfen Bluetooth bağlantısını kesmeyin ve yükseltme sırasında düzgün ağ çalışması sağlayın.",
		"strategyInfor": "Politika Bilgilerini Yükseltme",
		"policy_information": "Politika bilgileri",
		"end_time": "Bitiş zamanı",
		"strategy_type": "Ürün Yazılımı Türü",
		"strategy_upgrade_search": "Cihaz SN / Veri Kaydedici PN",
		"confirm": "Onaylamak",
		"strategy_time": "Etkili zaman",
		"Not_started": "Başlamadı",
		"uprade_fail": "Başarısız",
		"stategyDetail": "İsim",
		"default_desc": "Varsayılan Açıklama",
		"to": "Geri dön",
		"limits":"Hatırlatma: Yüklenen dosyada A sütunu veri toplayıcı PN olmalı, başlık gerekmez; aşağıdaki resmi örnek alabilirsiniz.",
		"mueas":"Yükseltme stratejisi",
		"upNum":"Yükseltilecek cihaz sayısı",
		"deletCL":"Stratejiyi sil",
		"deletCL_TEST":"Bu stratejiyi silmek istediğinize emin misiniz?",
		"ONE_UP":"Tek cihaz yükseltme",
		"MO_UP":"Toplu cihaz yükseltme",
		"MO_text": "Başarıyla içe aktarıldı",
"MO_tex1": "Yinelenen",
"MO_tex3": "Bulunamadı",
"MO_tex2": "Organizasyon",
"MO_tex4": "Firmware aktif politikada kullanılıyor, silinemez",
	},
	"retrieveUser": {
		"accountInfo": "Hesap bilgileri",
		"pleasePn": "Lütfen cihazı girin PN",
		"forgetUser": "Hesabı unuttum",
		"phone": "Hesabınıza bağlı telefon numarası",
		"Return_to_login": "Girişe dön",
		"illustrate": "Hesabınızı unutursanız, hesabınızın altına herhangi bir cihazın PN numarasını girerek hesabınızı geri çağırmanıza yardımcı olarak hesap bilgileri istemleri alabilirsiniz!",
		"pnError": "Girdiğiniz PN yanlış",
		"comfig": "Onaylamak",
		"pnErrorMsg": "Veri kaydedici bulunamadı",
		"user": "Kullanıcı adınız",
		"email": "Hesabınızla ilişkili e-posta şu şekildedir:",
		"pn": "Lütfen hesabınızın altındaki herhangi bir cihazın pn'sini girin"
	},
	"device": {
		"cancel": "İptal etmek",
		"year": "Cari yılda elektrik",
		"deleteSuc": "Başarıyla kaldırıldı!",
		"pageSize": "Sayfa boyutu",
		"noDataPlease": "Bir kişinin yetkileri",
		"Battery_voltage": "Batarya voltajı",
		"select_file": "Lütfen ürün yazılımını seçin",
		"confirm_deldte": "Silme onaylansın mı?",
		"brandDevice": "Cihaz",
		"familyLoad": "Ev yükü",
		"solar": "Güneş enerjisi",
		"clear_data": "Verileri temizle",
		"universal_firmware": "Evrensel Donanım Yazılımı",
		"select_brate": "Lütfen seçiniz Baud",
		"Send_Command": "Komut gönder",
		"showParam": "Seçenekleri göster",
		"gridPower": "Ağ gücü",
		"brand3": "Enerji depolama ünitesi",
		"upgrade": "Toplu güncelleme",
		"brand2": "İnvertör",
		"In_Upgrading": "Cihaz veya veri kaydedici zaten güncellemede",
		"edit": "Düzenlemek",
		"brand1": "Otonom invertör",
		"brand0": "Enerji depolama cihazı",
		"analysis": "Parametre analizi",
		"Cumulative_income": "Güç generasyondan toplam gelir",
		"sellProfit_Today": "Günlük elektrik satış gelirleri",
		"sellProfit_Total": "Elektrik satışlarından toplam gelir",
		"buyProfit_Today": "Şimdiki elektrik satın harcamaları",
		"buyProfit_Total": "Toplam elektrik satın harcamaları",
		"pvPower": "Güç üretimi",
		"cur_thismonth": "Bu ay için",
		"modify_alias": "Cihazı değiştir",
		"Device_sn": "Cihaz seri numarası",
		"device_code": "Protokol",
		"alternator": "Jeneratör",
		"detail": "Ayrıntı",
		"charged": "Şarj enerjisi",
		"device": "Cihaz",
		"cur_day": "Gün",
		"datalogger_pn": "Veri kaydedici numarası",
		"Equipment_agreement": "Donanım sözleşmesi",
		"loadPower": "Yük gücü",
		"standby": "Bekleme modu",
		"timeSlot": "Zaman aralığı",
		"select_type": "Lütfen donanım yazılımı türünü seçin",
		"alarmInfo": "Alarm Bilgileri",
		"battery": "Batarya",
		"Successfully_modified": "Başarıyla değiştirildi",
		"offline": "Çevrimdışı",
		"default": "Varsayılan",
		"copy_val_no": "Kopyalama hatası",
		"Upgrading": "Güncelleme, lütfen bekleyin",
		"copy_val_yes": "Başarılı kopyalama",
		"Send_fail": "Komut gönderme hatası",
		"control_firmware_bms": "BMS Donanım Yazılımı",
		"person_authority": "Yönetici hakları",
		"distribute": "Göndermek",
		"optionTitle": "Seçili",
		"optionTitle1": "term",
		"optionTitle2": "Aygıt parametrelerinin seçimi 4'den fazla geçemez",
		"optionTitle4": "Aygıt parametrelerinin seçimi 12'den fazla geçemez",
		"optionTitle3": "Lütfen 2 farklı birimden fazla seçenekleri seçme",
		"clause": "Ayrıntılı veriler",
		"debug_suc": "Başarılı hata ayıklama",
		"set": "Düzenlemek",
		"refresh": "Yenile",
		"inverter": "İnvertör",
		"clear_val": "Verileri temizle",
		"protocolStatistic": "Protokol istatistikleri",
		"dataloggerList": "Veri kaydedicilerin listesi",
		"confirm": "Onaylamak",
		"queryUpgrade": "Toplu istek güncelleme ilerlemesi",
		"device_cloudsUpgrade": "Donanım yazılımı:",
		"Debugfail": "Hata ayıklama hatası, donanım devre dışı bırakıldı.",
		"chart": "Veri tablosu",
		"Sn_deviceName": "SN / Cihaz adı / PN / Kullanıcı",
		"current_val": "Bugünkü değeri",
		"upFailDevice": "Başarısız cihaz güncellemesi",
		"copy_val": "Kopyalamak",
		"User_belong": "Kullanıcı",
		"deviceName": "Cihaz adı",
		"frequency": "Sıklık",
		"cloudUpgrade": "Bulut Yükseltme",
		"Device_pn": "Veri günlüğü numarası:",
		"generated": "Üretilen enerji",
		"deviceList": "Cihaz",
		"warning": "Uyarı",
		"device_address": "Cihaz adresi",
		"energyFlow": "Enerji verimliliği",
		"upgrade_brate": "Veri aktarım hızı:",
		"batteryPower": "Batarya şarjı",
		"firmware_type": "Donanım yazılımı türü:",
		"add": "Eklemek",
		"dataTips": "Mevcut cihaz çevrimdışı ve gerçek zamanlı verisi yok.",
		"upDevice": "Cihaz güncellemesi",
		"statistic": "İstatistik",
		"loadMore": "Daha fazla yükle...",
		"firmware_package_message": "Lütfen ürün yazılımını seçin",
		"Please_parameter": "Lütfen bir seçenek seçin",
		"Allthemachines": "Tüm cihazlar",
		"deviceNo": "Henüz bir cihaz eklemediniz",
		"firmware_step_message": "Lütfen adımları girin",
		"pro": "Proje",
		"deviceInfo": "Cihaz bilgisi",
		"moveSuc": "Başarıyla taşındı",
		"month": "Mevcut ay için elektrik",
		"return_content": "İade içeriği:",
		"pleaseDate": "Lütfen bir tarih seçin",
		"ownerShip": "Sahip Değişikliği",
    "oldOwner": "Eski Sahip:",
    "nweOwner": "Yeni Sahip:",
    "loading": "Yükleniyor...",
    "moreLoading": "Daha fazlasını yüklemek için kaydırın",
		"baudrate_message": "Lütfen seçiniz Baud",
		"unfollow": "Aboneliği iptal et",
		"upgradeProgress": "Güncel yükseltme ilerlemesi",
		"file_fist": "İlk önce ürün yazılımını seçin",
		"device_model": "Cihaz modeli",
		"followList": "Donanıma odaklanın",
		"continueUpgrade": "Yükseltmeye devam et",
		"device_name": "Cihaz adı",
		"Magnification": "Arttırmak",
		"Today_income": "Günlük enerji üretimi gelirleri",
		"addUpgradeSuccess": "Başarıyla eklendi",
		"numberRlues": "Lütfen doğru adım sayısını girin",
		"normal": "Normal",
		"sold": "Satılan enerji",
		"overview": "İstatistiklere genel bakış",
		"coll_alias": "Veri kaydedici adı",
		"device_upgradeStatus": "Güncelleme durumu",
		"relay": "Röle",
		"consumption": "Yüklemek",
		"Check_all": "Hepsini seç",
		"cur_month": "Ay",
		"noAuth": "Kullanıcı yok, görüntüleme izni yok",
		"step": "Başlangıç adımları:",
		"edit_control": "Cihaz yönetimi izinlerini değiştir",
		"noDate": "Gelecek bir tarih seçilemiyor",
		"device_upgrade": "Cihaz yazılımı güncelleniyor",
		"chosenParam": "Seçilen seçenek",
		"updatefail": "Güncelleme başarısız oldu, cihaz çevrimdışı.",
		"device_pn": "PN",
		"administrator_cansee": "Seçilen izinler alt yönetici tarafından görülebilir ancak temsilci görünmez.",
		"Instruction": "Talimat:",
		"device_upgradeTime": "Güncelleme zamanı",
		"Send_suc": "Komutu başarıyla gönder",
		"Cancel_all": "Hepsini iptal et",
		"discharged": "Boşaltma enerjisi",
		"communication_firmware": "Haberleşme Ürün Yazılımı",
		"cur_today": "Bugün",
		"deviceDebug": "Ekipman devreye alma",
		"generation": "PV",
		"Datalogger_belong": "Veri kaydedici",
		"field": "Saha kontrolü",
		"defaultUpgrade": "Varsayılan Yükseltme",
		"reset": "Tekrar yükle",
		"person_cansee": "Seçilen izinler sahip tarafından görülebilir, ancak temsilci görünmez.",
		"device_alias": "Cihaz adı:",
		"minSelect": "En az 1 parametre kontrol edilmelidir.",
		"deviceUpgradeProgress": "Ekipman yükseltme ilerlemesi",
		"maxSelect": "Maksimum sadece 7 parametre kontrol edilebilir",
		"Output_table": "Çıktı tablosu",
		"Upload": "İndirmek",
		"Input_form": "Giriş tablosu",
		"upgrade1": "Güncelleme",
		"more": "Daha Fazla İşlem",
		"one_click_read": "Tek Tıklamayla Oku",
		"device_code_form": "Protokol:",
		"power": "Güç",
		"device_sn": "Cihaz seri numarası",
		"bought": "Satın alınan enerji",
		"cur_thisyear": "Bu yılda",
		"upSuccessDevice": "Cihaz başarıyla güncellendi",
		"proList": "Projelerin listesi",
		"serial_number": "Cihaz seri numarası:",
		"grid": "Ağ",
		"control_firmware_slavmcu": "SlavMCU Donanım Yazılımı",
		"report": "Rapor",
		"upgradeType": "Yükseltme yöntemi:",
		"device_upgrade1": "Son güncelleme gönderisi",
		"uploadSuccess": "İndirme başarılı",
		"Current_data": "Güncel veri",
		"Upload1": "Yeni ürün yazılımını indirin",
		"Send_Input": "Lütfen gönderilecek işlemin değerini girin",
		"device_type": "Cihaz tipi",
		"selecParameters": "Seçilen parametre",
		"used": "Kullanılan enerji",
		"System_Failed": "Sistem, iletişim anormallikleri veya başka nedenlerle cihaz güncelleme işlemini başlatamadı.",
		"Unit": "Birim",
		"modifySuc": "Başarıyla değiştirildi",
		"cur_year": "Yıl",
		"firmware_type_message": "Lütfen bir tür seçin",
		"such_as": "Komutunuzu girin, örneğin: AA BB CC DD EE FF",
		"day": "Gerçek zamanlı güç",
		"obtain": "Elde etmek",
		"all": "Toplam Elektrik",
		"device_status": "Cihaz durumu",
		"read": "Saymak",
		"deleteDevice": "Cihazı sil",
		"update_suc": "Başarıyla güncellendi",
		"admin_authority": "Veri yok, başka bir zaman seçin",
		"continueUpgradeSuccess": "Başarıyla yükseltildi ve eklendi",
		"send": "Göndermek",
		"control_firmware1": "Kontrol Donanım Yazılımı 1",
		"datalogger": "Cihaz listesi",
		"control_firmware2": "Kontrol Donanım Yazılımı 2",
		"device_upgradeProgress": "Güncelleme ilerlemesi",
		"Operation": "Çalışmak",
		"delete": "Silmek",
		"addUpgrade": "Yükseltme Görevi Ekle",
		"Device_Offline": "Cihaz veya veri kaydedici devre dışı",
		"Field_Name": "Alan adı",
		"device_upgradeFirmware": "Cihazı güncellemek için donanım yazılımı paketini seçin",
		"Voltage": "Gerilim",
		"Update_Completed": "Güncelleme tamamlandı",
		"parameter": "Parametre",
		"device_continueUpgrade": "Ekipman yükseltmeye devam ediyor",
		"moveResults": "Sonuçları Taşı",
		"value": "Değer",
		"chooseProtocol": "Protokol seçin:",
		"optionalParam": "Ek parametre",
		"fileExceed": "Dosya boyutu aşıldı",
		"debug": "Hata ayıklama",
		"Electric": "Elektrik",
		"fault": "Hata",
		"control": "Kontrol",
		"select_firmware": "Lütfen donanım yazılımı dosyasını seçin",
		"follow": "Abone ol",
		"upBatchDeviceTip": "Not. Toplu güncelleme, aynı cihazın donanım yazılımını birden fazla cihaz için güncellemek içindir. Cihazınız için hangi üretici yazılımının uygun olduğunu bilmiyorsanız, lütfen dikkatlice seçin!",
		"cloudsUpgrade": "Bulut Yükseltme",
		"device_upgradeName": "Donanım yazılımı güncelleme adı",
		"instruction_response": "Talimatlar gönderiliyor, yanıt bekleniyor...",
		"error1": "Yalnızca .bin ve .hex biçimlerindeki dosyaları yükleyebilirsiniz!",
		"dataview": "Gerçek Zamanlı Seçenekler"
	},
	"account": {
		"cancel": "İptal etmek",
		"Delete": "Silmek",
		"enterHome": "Geri dönmek",
		"reason1": "Donanım verisi yok",
		"reason": "Grafiğin görüntülenmemesinin nedeni şunlar olabilir:",
		"role1": "Kullanıcı türü:",
		"reason2": "Ekipman sözleşmesinde elektrik üretimi, elektrik tüketimi, satın alınan güç, satılan güç, şarj gücü ve deşarj gücü parametreleri için alanlar yoktur.",
		"projects": "Projeler",
		"reason3": "Ekipman protokolünde güç üretimi, yük gücü, batarya gücü ve şebeke gücü için parametreler yoktur.",
		"resetPwdSuc": "Şifre sıfırlama başarılı!",
		"newPwd": "Yeni şifre",
		"deleteSuc": "Başarıyla kaldırıldı!",
		"binding": "Bağlamak",
		"Edit": "Düzenlemek",
		"groupsuccess": "Grup başarılı bir şekilde arttı!",
		"createSuc": "Hesap oluşturma başarılı!",
		"generalAccount": "Birincil hesap",
		"Individual_allocation": "Bireysel dağıtım",
		"password": "Şifre",
		"enablesuccess": "Başarıyla etkinleştirildi!",
		"enable": "Aç",
		"searchPro": "Proje araması",
		"accountManage": "Hesap",
		"relatedOwner": "İlgili sahibi",
		"confirmpassword": "Şifreyi onayla",
		"nickname1": "Takma ad:",
		"Assigned_successfully": "Başarıyla Atandı",
		"Confirm_assignment": "Randevuyu onaylayın",
		"selectUserType": "Lütfen kullanıcı türünü seçin!",
		"PNNum": "PN",
		"devices": "Cihazlar",
		"deletegroup": "Bu grubu terk et",
		"adminRelated": "Lütfen yöneticiyi seçin",
		"createAccount": "Oluşturmak",
		"operate": "Çalışmak",
		"groupManage": "Grup Yönetimi",
		"Distribution_method": "Dağıtım metodu",
		"IsIt": "bu",
		"userAccount": "Kullanıcı",
		"deleteUser": "Kullanıcıyı sil",
		"projectNum": "Cihaz sayısı",
		"deletegroupsuccess": "Gruptan çıkış başarılı!",
		"afterEnable": "Etkinleştirildikten sonra hesap, oturum açmak, ilgili hesap içeriğini görüntülemek veya düzenlemek için geri yüklenebilir.",
		"changeGroupSuc": "Grubu değiştirme başarılı!",
		"role": "Kullanıcı türü",
		"disablesuccess": "Başarıyla kapatıldı!",
		"groupto": "Gruplandır",
		"Distribution_collector": "Dağıtım toplayıcı",
		"confirmDisable": "Bu kullanıcının bağlantısının kesilmesi onaylansın mı?",
		"accountStatus": "Hesap durumu",
		"groupAccount": "Grup",
		"defaultGroup": "Varsayılan grup",
		"nickname": "Takma ad",
		"password1": "Şifre:",
		"email": "E-posta",
		"order_check": "Kontrol etmek",
		"relatedSuccess": "Birleşme başarılı oldu",
		"Deletesuccessfully": "Hesap silme başarılı!",
		"powerStationOwner": "İstasyon sahibi",
		"err_orderNum": "Sırasıyla",
		"tooltipContent": "Yönetici, siparişteki tüm veri toplayıcıları sipariş numarası ile bağlı bayiye atayabilir.",
		"distributor": "Distribütör",
		"Allocation_result": "Dağıtım sonucu",
		"confirm": "Onaylamak",
		"ownedDevices": "Kendi cihazları",
		"resetPwd": "Şifre sıfırlama",
		"activeStatus": "Aktif durum",
		"createTime": "Oluşturma zamanı",
		"placeholder1": "Bir kullanıcı adı/cep telefonu numarası girin",
		"disable": "Kapat",
		"accounts": "Hesaplar",
		"lastLogin": "Son giriş",
		"allGroup": "Tüm gruplar",
		"confirmpassword1": "Şifreyi onaylayın:",
		"editUser": "Kullanıcıyı değiştir",
		"cannotRedirect": "Bu hesap enerji depolama hesabı değildir, yönlendirme yapılamaz!",
		"modifiedsuccess": "Kullanıcı bilgileri başarıyla değiştirildi!",
		"email1": "E-posta:",
		"manageAccount": "Yönetim Hesabı",
		"Order_allocation": "Sipariş dağıtımı",
		"finish": "Sona ermek",
		"group": "Grup",
		"changeGroup": "Gruplamayı değiştir:",
		"limitFormat": "Yalnızca xlsx ve xls biçimindeki dosyaları yükleyebilirsiniz.",
		"ascription": "Üyelik",
		"ascriptionSuccess": "Başarısız",
		"ascription_result": "Özellik sonuçları",
		"newPwd1": "Yeni şifre:",
		"group1": "Grup:",
		"disableSuc": "Hesabın devre dışı bırakılması başarılı!",
		"currentTotal": "Güncel",
		"uselists": "Kullanıcı Yönetimi listesi",
		"powerStationViewer": "Güç istasyonu gözlemcisi",
		"afterDisable": "Devre dışı bırakıldığında, hesap oturum açamaz ve ilişkili hesap içeriği görüntülenemez veya değiştirilemez.",
		"unclassified": "Sınıflandırılmamış",
		"submit": "Değerlendirilmek üzere gönder",
		"newPwdEmpty": "Yeni şifre boş geçilemez, lütfen doldurunuz!",
		"accountName": "Kullanıcı adı",
		"pwdresetsuccess": "Şifre başarıyla sıfırlandı!",
		"order_number": "Sipariş numarası",
		"mobile1": "Mobil:",
		"admin": "Yönetici",
		"riyueyuan_lineSonAdmin": "Üretim hattı altı yöneticisi",
		"riyueyuan_SonAdmin": "Alt yönetici",
		"plantOwner": "İstasyon sahibi",
		"accountName1": "Kullanıcı adı",
		"accountName2": "Tek bir kullanıcı adı girin",
		"Batch_allocation": "Toplu dağıtım",
		"deviceNum": "Cihaz",
		"chooseGroup": "Lütfen grubu seçin",
		"editAccount": "Hesabı düzenle",
		"notRecovered": "Silme işleminden sonra kurtarma mümkün değildir...",
		"placeholder": "Kullanıcı adı/cep telefonu numarası arama",
		"accountRole": "Rol",
		"Ple_orderNum3": "toplayıcılar, seçimi doğrulayın",
		"Ple_orderNum2": "Bu sipariş var",
		"Ple_orderNum": "Lütfen sipariş numaranızı giriniz",
		"Ple_orderNum1": "Lütfen geçerli bir sipariş numarası girin",
		"lastLoginTs": "Son giriş zamanı",
		"mobile": "Telefon",
		"accountGroup": "Kullanıcı grubu",
		"nodata": "Veri yok",
		"allTypeUser": "Tüm kullanıcı türleri",
		"confirmDelete": "Silmeyi onayla?",
		"confirmEnable": "Bu kullanıcının etkinleştirilmesi onaylansın mı?",
		"dataloggerNum": "Veri kaydedicileri",
		"allAccount": "Tüm kullanıcılar",
		"err_orderNum1": "Veri kaydediciler bağlandı. Lütfen siparişteki kayıt operatörlerinin birbiriyle ilişkili olmadığını doğrulayın",
		"accountList": "Hesapların listesi",
		"dataogger_swith": "Veri alma aygıtı ekle",
		"dataogger_swithTip": "Bu hesap veri koleksiyoncularını eklemek için izni alabilir mi?",
		"account_number": "Hesap numarası",
		"Role_authority": "Mahkeme",
		"authority_Management": "İzin yönetimi",
		"Related_roles": "İlişkili roller",
		"Ple_role1": "Lütfen ilişkin rolünü seçin",
		"Ple_role2": "Lütfen rol adı/kimliğini girin",
		"Add_role": "Yeni rol ekle",
		"Edit_role": "Rolü Düzenle",
		"Role_id": "Rol Kimliği",
		"Role_name": "Rol İsmi",
		"Ple_role3": "Lütfen rol adını girin",
		"Role_des": "Rol tarifi",
		"Ple_role4": "Lütfen rol tasvir girin",
		"module": "Modüler",
		"First_page": "Sayfa",
		"Secondary_page": "İkinci sayfa",
		"Function_points": "Funksiyon noktaları",
		"Remove_role": "Rol Sil",
		"Ple_role5": "Lütfen hesap izinlerini kontrol edin",
		"No_permission_prompt": "İzniniz yok, lütfen yüksek seviye yöneticisine bağlantı edin",
		"Ple_role6": "Rol adı zaten mevcut. Lütfen yeniden girin.",
		"limit_UserTypeNum": "Sınırdan fazla, bu hesap tipi zaten mevcut.",
		"limit_UserTypeDataPermission": "Bayi hesapları, seçilen veri izinleri olan rolleri bağlayamaz.",
		"edit_limit_UserTypeDataPermission": "Rol, bayi hesaplarıyla ilişkilendirildi ve veri izinleri düzenlenemez.",
		"dataPermission": "Veri izni",
		"functionalPermission": "Fonksiyonel izin"
	},
	"browse": {
		"pleaseUsr": "Lütfen bir alt hesap girin",
		"deleteBrowse": "Silmek",
		"pleaseDevice": "Öğe Seç",
		"editBrowse": "Alt Hesabı Düzenle",
		"addSuccess": "Başarıyla alt hesap eklendi",
		"password": "Şifre",
		"usr": "Alt hesap",
		"pleaseDevice_title": "Lütfen bir proje seçin",
		"deleteSuccess": "Başarıyla kaldırıldı!",
		"confirmPassword": "Şifreyi onayla",
		"Enable": "Aç",
		"Disable": "Kapat",
		"email": "E-posta",
		"accountInfo": "Hesap bilgileri",
		"delete_browse": "Alt hesabı sildiğinizden emin misiniz?",
		"addBrowse": "Alt Hesap Ekle",
		"gts": "Kayıt tarihi",
		"mobile": "Telefon",
		"newPassword": "Yeni şifre",
		"editSuccess": "Başarıyla düzenlenmiş alt hesap",
		"please_browsepwd": "Lütfen yeni şifreyi kontrol edin ve şifre giriş gereksinimlerini onaylayın",
		"pleaseStatus": "Durum Seç",
		"device": "Proje Seçimi",
		"usrInfo": "kullanıcı bilgileri",
		"enableStatus": "Durumu Etkinleştir",
		"username": "Kullanıcı adı",
		"desc": "Desc"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Enerji akış veri toplama hızlandırması",
		"collect_fast2": "Enerji akışı hızlandırma",
		"collect_fast_fail": "Hızlandırma başarısız oldu, lütfen tekrar deneyin",
		"collect_fasting": "Hızlandırma",
		"collect_fast_starting": "Hızlandırma başlatılıyor",
		"collect_fast1": "Detaylı Veri Toplama Hızlandırması",
		"collect_fast1ing": "Veri Hızlandırılıyor",
		"paySecCon": "Ödeme onayı",
		"energyFetchPic": "Aşağıdaki şekilde enerji akışı haritası sayfa parametreleri için yükleme, yükleme hızlanma aralığı onaylanmış olup olmadığını",
		"historyFetchPic": "Yüklemeyi onaylayıp onaylamadığını, aşağıdaki şekilde ayrıntılı sayfa parametreleri için yüklemenin hızlanma aralığı",
		"reRechargeTip1": "Mevcut cihaz için enerji akışı hızlandırma hizmeti zaten satın alındı. Satın almaya devam etmek tekrar ücretlendirmeye neden olacaktır. Devam etmek istiyor musunuz?",
		"reRechargeTip": "Mevcut cihaz için veri ayrıntıları hızlandırma hizmeti zaten satın alındı. Satın almaya devam etmek tekrar ücretlendirmeye neden olacaktır. Devam etmek istiyor musunuz?",
		"continueRecharge": "Yüklemeye devam et",
		"collect_fasting_title": "Gerçek Zamanlı Parametreler Saklanmaz",
		"collect_Order_Record": "Hızlandırılan kayıt",
		"Collection_terms": "Koleksyon frekans hızlandırma şartları",
		"Recharge_failed_next": "Başarısız yükleme için üzgünüm, tekrar ödemeye çalışabilirsiniz.",
		"view_order": "Emirleri görüntüle",
		"Once": "saniye",
		"every_interval": "Şu anda seçilen hızlandırma belirtisi: her aralık",
		"Collect_terms2": "1,Paketin uygulaması alanı",
		"Collect_terms3": "Yeniden yüklemek için koleksiyoncular tarafından kullanılan protokolde dahil edilen görüntü parametreleri (not: eğer hızlandırılmış yenileme için Enerji Akış Grafik sayfasını seçerseniz, paketin genişliği Enerji Akış Grafik sayfasının görüntüleme alanına sınırlı; eğer hızlandırılmış yenileme için Tarihi Veri sayfasını seçerseniz, paketin genişliği Tarihi Veri sayfasının görüntüleme alanına sınırlı)",
		"Collect_terms4": "2, protokol/aygıt yerini desteklemez",
		"have_read": "Tam olarak okudum.",
		"Collect_terms5": "Protokoller/aygıtları değiştirmek hızlandırma eğlencesine katılmıyor",
		"Collect_terms6": "3, Paketi Çıkart",
		"Collect_terms": "Hızlı yeniden yükleme şartlarını topla",
		"View_Details": "Ayrıntıları Görüntüle",
		"Recharge_result": "Tekrar yükle sonuçları",
		"Collect_terms7": "Ödemeden sonra desteklenmeyecek ve değiştirme",
		"Online_payment": "Online ödeme",
		"Collect_terms8": "4, Paket fiyatı",
		"Collect_terms9": "Parametre miktarınıza dayanarak, hızlandırılmış koleksiyon frekanslarına ve yük kapasitesine dayanarak ödemelerimiz hesaplanıyor ve son fiyat bu şekilde karar verildi. Yukarıdaki şartlarda, tarihi veriler de depolama zamanı",
		"acquisition_frequency": "Kolleksiyon frekansı",
		"Recharge_failed": "Yeniden yükleme başarısız oldu",
		"Recharge_amount": "Tekrar yükle miktarı",
		"Scan_payment": "Kod ödemesini tara",
		"collect_recharge": "Veri Toplama Hızlandırması Yeniden Yüklemesi (Detaylı Veri Toplama Hızlandırması)",
		"collect_recharge1": "Veri Toplama Hızlandırması Yeniden Yüklemesi (Enerji Akışı Hızlandırması)",
		"Collect_terms10": "5,Trafik tüketimi",
		"Purchase_Terms7": "Başka sorular var.",
		"Purchase_Terms8": "Eğer başka bir sorunuz varsa, internet müşterilerimizle danışmanız için iletişim kurabilirsiniz ve size detaylı cevaplar veririz.",
		"Collect_terms11": "Kolleksiyon frekansiyasını hızlandırmak trafik tüketimini arttıracak",
		"Purchase_Terms6": "Parametre miktarınıza dayanarak, hızlandırılmış koleksiyon frekanslarına ve yük kapasitesine dayanarak ödemelerimiz hesaplanıyor ve son fiyat bu şekilde karar verildi. Yukarıdaki şartlarda, tarihi veriler de depolama zamanı",
		"Purchase_Terms5": "Paket Ödülü",
		"Purchase_Terms4": "Lütfen yeni versiyonumuza göz kulak ol. Şimdiki versiyon sadece tüm görüntü parametrelerini toplamaya ve geliştirmeye destekliyor. Bütün rahatsızlıklar için özür dileriz!",
		"Purchase_Terms3": "Bazı parametreler için koleksiyon frekanslarını özelleştirebilirim",
		"Real_parameters": "Gerçek zamanlı parametreler",
		"Purchase_Terms1": "Toplama Hızlandırma Geçerlilik Süresi",
		"Purchase_Terms2": "Toplama hızlandırma hizmetinin sona erme süresi, satın aldığınız paketin süresine göre otomatik olarak hesaplanacaktır. Kesin sona erme süresi sayfada gösterilene tabidir",
		"device_Info": "Equipment bilgisi",
		"Recharge_successful_next": "Başarılı yeniden yüklenmeniz için tebrik ederiz. Kolleksiyonunuz frekansiyonunu geliştirmek üzereyiz. Kolleksiyonunuz frekansiyonlarınızın değişimlerini takip edebilirsiniz.",
		"Purchase_Terms": "Kullanın Termleri",
		"gather": "koleksiyon",
		"Recharge_time": "Tekrar yükleme vakti",
		"Payment_method": "Ödeme yöntemi",
		"Type": "Taşıma Türü",
		"Recharge_now": "Şimdi yeniden yükle",
		"History_Data": "tarihi veri",
		"Collect_terms1": "Kolleksyon frekans hizmeti hızlandırma hizmeti şartları",
		"Package": "Hızlandırma Paketi",
		"PN_order": "PN/Düzenleme Numarası",
		"Order_No": "sıra numarası",
		"Recharge_successful": "Yeniden yükleme başarılı",
		"noRecharg": "Kollektör yeniden yüklemeyi desteklemez.",
		"noRecharg_min": "Koleksyon hızınız en hızlı ulaştı!",
		"noRecharg_wifi": "Ağımdaki sürüm sadece Wi-Fi modülü veri alınmasını destekliyor",
		"paypalTip": "Son ödeme miktarı PayPal'a dayanmaktadır",
		"upPrice": "Farklılık",
	},
	alarmNew: {
		'fileName': 'Dosya Adı',
		'fileSize': 'Dosya Boyutu',
		'fileStatus': 'Dosya Durumu',
		'progress': 'İlerleme',
		'can': 'İndirilebilir',
		'no': 'Dışa Aktarılıyor',
		'history': 'Dışa Aktarma Geçmişi'
	},
		shuoriExport:{
       "exportRecords": "Dışa Aktarma Kayıtları",
       "export": "Dışa Aktar",
       "exportTask": "Dışa aktarma görevi oluşturuldu. Lütfen dosyayı daha sonra 'Dışa Aktarma Kayıtları' bölümünden indirin.",
       "noDownload": "Dosya bağlantısı geçersiz veya indirilemiyor. Lütfen tekrar deneyin.",
	   'data': 'Tarih',
	},
		colUnBindRecord: {
	'UnBindRecord': 'Veri Toplayıcı Bağlantı Kesme Kaydı',
    "unStatus": "Bağlantı Kesme Durumu",
    "unScene": "Bağlantı Kesme Senaryosu",
    "oldUser": "Orijinal Kullanıcı",
    "newUser": "Yeni Kullanıcı",
    "unCount": "Bağlantı Kesme Sayısı",
    "pnBarCode": "PN Barkod",
    "devicePicture": "Cihazın Gerçek Fotoğrafı",
    "ip": "Bağlantısı Kesilen IP",
    "unTime": "Bağlantı Kesme Zamanı"
	},
		rosRecharge: {
		'electronicInvoicing': 'Elektronik Fatura Kesme',
		'issueEInvoice': 'Elektronik Fatura Kes',
		'invoiceHistory': 'Fatura Geçmişi',
		'rechargeDuration': 'Yenileme Süresi',
		'year': 'yıl',
		'month': 'ay',
		'day': 'gün',
		'days': 'gün',
		'pendingPayment': 'Ödeme Bekliyor',
		'paymentSuccess': 'Ödeme Başarılı',
		'paymentFailed': 'Ödeme Başarısız',
		'orderClosed': 'Sipariş Kapatıldı',
		'serviceTerminated': 'Hizmet Sonlandırıldı',
		'unpaid': 'Ödenmedi',
		'paying': 'Ödeniyor',
		'paid': 'Ödendi',
		'refunded': 'İade Edildi',
		'cancelled': 'İptal Edildi',
		'rechargeSuccess': 'Yenileme Başarılı',
		'rechargeFailed': 'Yenileme Başarısız',
		'pleaseSelectDate': 'Lütfen tarih seçin',
		'orderNo': 'Sipariş No',
		'batchInvoicing': 'Toplu Fatura Kesme',
		'rechargeType': 'Yenileme Türü',
		'trafficRecharge': 'Veri Yenileme',
		'collectRecharge': 'Toplama Yenileme',
		'rechargeStatus': 'Yenileme Durumu',
		'invoice': 'Fatura',
		'invoiceStatus': 'Fatura Durumu',
		'invoiceTime': 'Fatura Kesme Zamanı',
		'viewDetail': 'Ayrıntıları Görüntüle',
		'invoicing': 'Fatura Kesiliyor',
		'invoiceSuccess': 'Fatura Kesildi',
		'invoiceFailed': 'Fatura Kesme Başarısız',
		'issueElectronicInvoice': 'Elektronik Fatura Kes',
		'invoiceType': 'Fatura Türü',
		'generalInvoice': 'Normal Fatura',
		'specialInvoice': 'Özel Fatura',
		'headerType': 'Başlık Türü',
		'companyHeader': 'Şirket Başlığı',
		'personalHeader': 'Bireysel/Kurumsal Olmayan Başlık',
		'pleaseInputCompanyHeader': 'Lütfen şirket başlığını girin',
		'taxNumber': 'Şirket Vergi Numarası',
		'pleaseInputTaxNumber': 'Lütfen vergi mükellef kimlik numarasını girin',
		'headerName': 'Başlık Adı',
		'suggestPersonalName': 'Kişisel ad/mağaza adı girilmesi önerilir',
		'invoiceContent': 'Fatura İçeriği',
		'internetCommService': 'İnternet İletişim Hizmetleri',
		'invoiceAmount': 'Fatura Tutarı',
		'yuan': 'TL',
		'moreInfo': 'Daha Fazla Bilgi',
		'remarkAddressEtc': 'Açıklama, adres vb.',
		'companyAddress': 'Şirket Adresi',
		'pleaseInputCompanyAddress': 'Lütfen şirket adresini girin',
		'companyPhone': 'Şirket Telefonu',
		'pleaseInputCompanyPhone': 'Lütfen şirket telefonunu girin',
		'openingBank': 'Hesap Bankası',
		'pleaseInputOpeningBank': 'Lütfen banka adını girin',
		'bankAccount': 'Banka Hesabı',
		'pleaseInputBankAccount': 'Lütfen banka hesap numarasını girin',
		'remark': 'Açıklama',
		'pleaseInputRemark': 'Lütfen açıklama girin',
		'email': 'E-posta',
		'pleaseInputEmail': 'Lütfen e-posta adresinizi girin',
		'cancel': 'İptal',
		'submit': 'Gönder',
		'invoiceResult': 'Fatura Kesme Sonucu',
		'invoiceSubmitted': 'Fatura Başvurusu Gönderildi',
		'invoiceExpectedTip': 'Fatura 48 saat içinde kesilecektir, lütfen e-postanızı kontrol edin',
		'viewInvoiceStatus': 'Fatura Durumunu Görüntüle',
		'pleaseInputHeaderName': 'Lütfen başlık adını girin',
		'pleaseInputValidEmail': 'Lütfen geçerli bir e-posta adresi girin',
		'invoiceApplyFailed': 'Fatura Başvurusu Başarısız',
		'viewInvoice': 'Faturayı Görüntüle',
		'downloadPdf': 'PDF Dosyasını İndir',
		'manualService': 'Müşteri Hizmetleri',
		'invoiceSentToEmail': 'Fatura bilgisi e-postanıza gönderildi, lütfen kontrol edin',
		'pleaseWaitInvoicing': 'Lütfen fatura kesme işleminin tamamlanmasını bekleyin',
		'pleaseContactManual': 'Lütfen fatura kesmek için müşteri hizmetleriyle iletişime geçin',
		'noPdfAvailable': 'İndirilecek PDF dosyası yok',
		'serviceUnavailable': 'Müşteri hizmetleri şu anda kullanılamıyor',

	}
}
export default tr;
